import "core-js/modules/es.array.push.js";
import "core-js/modules/web.dom-exception.stack.js";
import "core-js/modules/es.typed-array.at.js";
import "core-js/modules/es.typed-array.find-last.js";
import "core-js/modules/es.typed-array.find-last-index.js";
import "core-js/modules/es.typed-array.set.js";
import AgoraClient from '@/assets/js/rtc-client-ng';
import newAgoraClient from '@/assets/js/newRtcClient.js';
import Tool, { addTabTitle, handleLocalStorage, returnSourceType, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
import { controlCamera, controlAudio, controlDeviceBehavior, controlDevicePublish, changeBehaviorStatus } from '@/assets/js/attendUser.js';
import VolumeBar from '@/assets/js/volumeBar.js';
import { wsDispatcher } from '@/assets/js/wsDispatcher';
import { useShortCut } from '@/hooks/shortcut';
import { getCurrentInstance, onBeforeUnmount } from 'vue';
export default {
  setup() {
    const {
      onTrigger
    } = useShortCut();
    const vm = getCurrentInstance().proxy;
    const stop = onTrigger(({
      type
    }) => {
      switch (type) {
        case 'leaveParty':
          Bus.$emit('showDialog', {
            show: true,
            realPartyCode: vm.partyCode,
            rtilCode: vm.userInfo.rtilCode
          });
          break;
        case 'controlCamera':
          vm.dealCamera(!vm.State.cameraStatus[vm.userInfo.rtilCode]);
          break;
        case 'controlMic':
          vm.dealMic(!vm.State.micStatus[vm.userInfo.rtilCode]);
          break;
        case 'controlSpeaker':
          vm.changeMute(!vm.State.isMute);
          break;
        case 'controlShare':
          vm.shareScreen(vm.shareRtilCode ? 'stopShare' : 'share');
          break;
        case 'controlChat':
          vm.dealShowChat(!vm.State.showChatMessage);
          break;
      }
    });
    onBeforeUnmount(() => {
      if (typeof stop === 'function') stop();
    });
  },
  data() {
    return {
      pressStartTime: 0,
      longPressTimer: null,
      isNotLoginArray: [],
      osLevelmicMuted: false,
      showMicMutedInfo: {
        show: false,
        title: 'micMutedInfo.title',
        hideSave: true,
        hideCancel: true,
        showGotIt: true,
        gotIt: 'micMutedInfo.ignore'
      },
      checkRemindMe: false,
      aiPolicyInfo: {
        showRemindMe: true,
        title: 'aiSpeech.aiPolicyTitle',
        save: 'common.gotIt',
        show: false
      },
      langArray: [{
        label: 'Auto',
        val: ''
      }, {
        label: 'English',
        val: 'English'
      }, {
        label: 'Chinese Simplified',
        val: '中文简体'
      }, {
        label: 'Chinese Traditional',
        val: '中文繁體'
      }, {
        label: 'Korean',
        val: 'Korean'
      }, {
        label: 'Japanese',
        val: 'Japanese'
      }, {
        label: 'Spanish',
        val: 'Spanish'
      }, {
        label: 'Portugues',
        val: 'Portugues'
      }, {
        label: 'French',
        val: 'French'
      }],
      showTranslate: false,
      translateInto: '',
      summaryInfo: {
        show: false,
        title: 'common.summary',
        cancel: 'galleryHost.cancel',
        info: {}
      },
      summary: '',
      showAISpeech: false,
      pipVolume: '',
      degreeHost: {},
      deviceType: {},
      resizeTimer: null,
      videoCanvasWidth: '',
      videoCanvasColumn: '',
      allRtilList: [],
      rtilCodeList: [],
      shareInitiator: '',
      shareList: {},
      rtilCodeByShare: {},
      cameraId: '',
      needStartVoip: false,
      microphoneId: '',
      praivateParams: {},
      talkBackInfo: {},
      controlMuteInfo: {},
      rtilStatusObj: {},
      wsPageSTimer: null,
      talkbackStatus: false,
      showUnread: false,
      lockName: true,
      audioLevel: true,
      aduioHover: false,
      channels: {},
      rtc: null,
      newRtc: null,
      shareClient: null,
      videoInfo: {},
      isWeixin: navigator.userAgent.includes('MicroMessenger'),
      shareParams: {},
      partyCode: '',
      rtilCode: 0,
      PartyLineRequest: null,
      MeInfo: {},
      MeInfos: {},
      setNameInfo: {
        show: false
      },
      behaviorInfo: {},
      avatarInfo: {},
      userInfo: {},
      joinParam: {},
      devicesInfo: {},
      outputRtilCode: '',
      currentBitrate: '',
      videoProfile: '',
      CameraTips: {
        hideSave: false,
        hideCancel: false,
        showGotIt: false,
        gotIt: 'galleryParticipant.gotIt',
        title: 'galleryParticipant.cameraTips',
        content: '',
        cancel: 'galleryParticipant.deny',
        save: 'galleryParticipant.admit',
        show: false
      },
      coHostInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      collaborateInfo: {
        show: false,
        title: 'personalInfo.Permission',
        save: 'personalInfo.accept',
        cancel: 'personalInfo.decline',
        info: {}
      },
      controlMediaInfo: {
        show: false,
        title: 'common.operatPermission',
        save: 'galleryParticipant.admit',
        cancel: 'galleryParticipant.deny',
        info: {}
      },
      rtcLoaded: false,
      selectRid: '',
      sourceId: '',
      lastAudioOperationTime: 0,
      // 用来显示快速点击的问题
      lastVideoOperationTime: 0,
      // 用来显示快速点击的问题
      initVideoPopup: true,
      initAudioPopup: true,
      allPartyMembers: [],
      shareRtilCode: '',
      remoteNetWorks: {},
      showPipCursorPointer: true,
      lowNetworkTime: 0,
      muteAmAudio: false,
      lowNetwork: false,
      hostControlPipRtilCode: {},
      startHearSelf: false,
      hearSelf: true,
      isFullScreen: false,
      passWord: '',
      iconList: ['leaveParty', 'camera', 'mic', 'speaker', 'share', 'chat', 'voice'],
      initAudioOnlyPopup: true,
      myselfMuteInfo: {},
      hadOpenWebCloud: false,
      settingPopupInfo: {
        show: false
      },
      fullScreenInfo: [],
      devicePlatform: {},
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      intercom: 0,
      localVolume: 0,
      keepInCurrentLine: true,
      sttRtilCode: '',
      rtilCodeKeyTypeVal: {},
      speechTimer: null,
      needReMute: false,
      sendPrivateToMeRtilcodes: [],
      sttHistoryList: [],
      hasGetTimeOffset: false,
      bestOffset: 0,
      sendMetadataTimer: null,
      largeScreenRtilCode: '' // left and right layout rtilCode
    };
  },

  computed: {
    ...mapState({
      State: state => state,
      isMute: state => state.isMute,
      Config: state => state.config,
      loginInfo: state => state.loginInfo,
      resolutionRange: state => state.resolutionRange,
      logoGray: state => state.logoGray,
      participantInfo: state => state.participantInfo
    }),
    formattedText() {
      return this.State.summaryInfo.contentText.replace(/\n/g, '<br>');
    },
    existMeShare() {
      let flag = false;
      Object.keys(this.shareList).forEach(key => {
        if (!flag && this.shareList[key] == this.userInfo.rtilCode) {
          flag = true;
        }
      });
      return flag;
    },
    operateList() {
      const obj = {};
      Object.keys(this.channels).forEach(id => {
        obj[id] = [];
        id != this.channels[id].shareCode && obj[id].unshift('fullScreen');
        if (id != this.channels[id].shareCode && this.State.cameraStatus[id]) {
          obj[id] = ['fullScreen'];
        }
      });
      if (this.State.cameraStatus[this.userInfo.rtilCode]) {
        obj[this.userInfo.rtilCode] = ['fullScreen'];
      }
      if (!this.lockName) {
        if (obj[this.userInfo.rtilCode]) {
          obj[this.userInfo.rtilCode].push('rename');
        } else {
          obj[this.userInfo.rtilCode] = ['rename'];
        }
      }
      return obj;
    },
    showTitle() {
      if (this.outputRtilCode) return 'danger';
      return '';
    },
    returnVideoClass() {
      let _str = '';
      if (!this.degreeHost[this.MeInfo.id]) {
        _str += !this.State.needLocalMirror ? '' : 'rotate0Mirror';
      } else if (this.degreeHost[this.MeInfo.id] == 0) {
        _str += !this.State.needLocalMirror ? 'rotate0' : 'rotate0Mirror';
      } else if (this.degreeHost[this.MeInfo.id] == 90) {
        if (this.fullRotate && this.State.isVertical) {
          _str += !this.State.needLocalMirror ? 'rotateFull90' : 'rotateFull90Mirror';
        } else {
          _str += !this.State.needLocalMirror ? 'rotate90' : 'rotate90Mirror';
        }
      } else if (this.degreeHost[this.MeInfo.id] == 180) {
        _str += !this.State.needLocalMirror ? 'rotate180' : 'rotate180Mirror';
      } else if (this.degreeHost[this.MeInfo.id] == 270) {
        if (this.fullRotate && this.State.isVertical) {
          _str += !this.State.needLocalMirror ? 'rotateFull270' : 'rotateFull270Mirror';
        } else {
          _str += !this.State.needLocalMirror ? 'rotate270' : 'rotate270Mirror';
        }
      }
      return _str;
    }
  },
  watch: {
    'State.showAISpeech': {
      handler: function (newValue) {
        const aiPolicyNotShown = handleLocalStorage('get', `aiPolicyNotShown_${handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime()}`) == 'true';
        if (newValue && !aiPolicyNotShown) {
          this.aiPolicyInfo.show = true;
        }
      },
      immediate: true
    },
    rtilCodeList() {
      this.$nextTick(() => {
        this.changeLayout();
      });
    },
    largeScreenRtilCode(val, oldVal) {
      this.$nextTick(() => {
        this.changeLayout();
        if (val && this.$refs.mainwindowBox) {
          this.$refs.mainwindowBox.changeFullScreenVal(!!val);
        }
        if (oldVal && oldVal == this.userInfo.rtilCode) {
          var _this$rtc, _this$rtc$_localVideo;
          (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : (_this$rtc$_localVideo = _this$rtc._localVideoTrack) === null || _this$rtc$_localVideo === void 0 ? void 0 : _this$rtc$_localVideo.play('local_stream');
        }
        if (oldVal && oldVal == this.outputRtilCode && this.$refs[`remoteSource${this.outputRtilCode}`] && this.$refs[`remoteSource${this.outputRtilCode}`][0]) {
          this.$refs[`remoteSource${this.outputRtilCode}`][0].changeFullScreenVal(false);
          Bus.$emit('changeMainwindowFullScreen', {
            value: false,
            id: oldVal
          });
        }
      });
    }
  },
  created() {
    this.newRtc = new newAgoraClient();
    this.addRtcEventListener();
    this.wsAddEventListener();
    Bus.$on('setPartyTitle', v => {
      document.title = this.$t('common.partyTitle', {
        name: v.title
      });
    });
    const {
      id
    } = this.$route.query;
    const {
      passWord
    } = this.$route.params;
    this.partyCode = id;
    this.passWord = passWord;
    window.addEventListener('keydown', this.listenerKeyDown);
    window.addEventListener('keyup', this.listenerKeyUp);
    // 清除之前与会者以host的身份登录的登录信息，
    Tool.removeHostLoginInfo();
    // 判断是setNickname还是join
    this.setNameOrJoin();

    // 记录与会者进入页面方式
    sessionStorage.setItem('enterPartyType', 'web');

    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.$route.query.id) return;
      this.pageSerBusCallback(v);
    });
    gtag('event', 'pageView-Common party participate', {
      event_category: 'pageView',
      event_label: '会议模块',
      value: 'Common party participate'
    });
    Bus.$on('setVoiceCommandProduction', v => {
      const {
        productionId
      } = v;
      this.State.productionId = productionId;
    });
    Bus.$off('downlinkNetworkQuality');
    Bus.$on('downlinkNetworkQuality', val => {
      // 判断当前所选择的 audio-only 模式，如果是 all time 的话则不需要走这段逻辑
      if (this.State.audioType || this.State.audioType == 2) return;
      // 当连续8s处于若网时，则改为只订阅音频流,连续6s状态良好则恢复订阅视频流
      if (val < 4) {
        if (this.lowNetworkTime > 0) {
          this.lowNetworkTime--;
        } else {
          this.lowNetworkTime = 0;
        }
        if (this.lowNetwork && this.lowNetworkTime === 0) {
          this.lowNetwork = false;
          Object.keys(this.channels).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].videoTrack && this.channels[rtilCode].hasUnsubscribe) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            }
          });
          this.State.inAudioOnlyStatus = false;
          this.initAudioOnlyPopup = true;
        }
      } else {
        if (this.lowNetworkTime < 3) {
          this.lowNetworkTime++;
        } else if (this.lowNetworkTime === 3) {
          this.lowNetwork = true;
        }
        if (this.lowNetwork) {
          Object.keys(this.channels).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].videoTrack && !this.channels[rtilCode].hasUnsubscribe) {
              if (!((this.outputRtilCode == rtilCode || this.largeScreenRtilCode == rtilCode) && this.State.checkMainWindow) && !(this.shareList[rtilCode] && this.State.checkShareScreen)) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
                this.channels[rtilCode].hasUnsubscribe = true;
              }
            }
          });
          this.State.inAudioOnlyStatus = true;
          if (this.initAudioOnlyPopup) {
            this.initAudioOnlyPopup = false;
            this.$message.success(this.$t('netWorkStatus.poorNetworkPopup'));
          }
        }
      }
    });
    Bus.$on('subscribeAudioControl', val => {
      if (val) {
        if (val == 2) {
          Object.keys(this.channels).forEach(rtilCode => {
            if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].hasUnsubscribe) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            }
          });
          return; // 2 是关闭 audio-only 状态不用订阅
        }

        Object.keys(this.channels).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && !this.channels[rtilCode].hasUnsubscribe) {
            // 需要判断当前的 mainWindow 和 shareScreen 是否处于选中状态，选中需要订阅
            if (this.outputRtilCode == rtilCode || this.largeScreenRtilCode == rtilCode) {
              if (!this.State.checkMainWindow) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
                this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
              }
            } else if (this.shareList[rtilCode]) {
              if (!this.State.checkShareScreen) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
                this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
              }
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', '', false);
              this.$set(this.channels[rtilCode], 'hasUnsubscribe', true);
            }
          }
        });
      } else {
        Object.keys(this.channels).forEach(rtilCode => {
          if (rtilCode != this.userInfo.rtilCode && this.channels[rtilCode].hasUnsubscribe) {
            // 需要判断当前的 mainWindow 和 shareScreen 是否处于选中状态，选中需要订阅
            if (this.outputRtilCode == rtilCode) {
              // 分为两种情况一种网络较好(可以不取参考checkbox)，另外一种是网络不好需要参考checkbox
              if (!this.State.inAudioOnlyStatus) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                this.channels[rtilCode].hasUnsubscribe = false;
              } else {
                if (this.State.checkMainWindow) {
                  this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                  this.channels[rtilCode].hasUnsubscribe = false;
                }
              }
            } else if (this.shareList[rtilCode]) {
              if (!this.State.inAudioOnlyStatus) {
                this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                this.channels[rtilCode].hasUnsubscribe = false;
              } else {
                if (this.State.checkShareScreen) {
                  this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
                  this.channels[rtilCode].hasUnsubscribe = false;
                }
              }
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            }
          }
        });
      }
    });
    Bus.$on('dealMainAudioOnly', val => {
      const pinnCode = this.outputRtilCode || this.largeScreenRtilCode;
      if (pinnCode) {
        // 先判断当前处于哪种模式下
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[pinnCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[pinnCode].hasUnsubscribe = false;
            } else {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[pinnCode].hasUnsubscribe = true;
            }
          }
        } else {
          // 如果是 auto audio-only 需要先判断当前是否处于 audio-only 状态中
          if (!this.State.inAudioOnlyStatus && this.rtc) {
            this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[pinnCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[pinnCode].hasUnsubscribe = false;
            } else {
              this.dealLocalShareScreen(pinnCode, 'needControlPlay', 'unExecuteCallback', false);
              this.channels[pinnCode].hasUnsubscribe = true;
            }
          }
        }
      }
    });
    Bus.$on('dealShareAudioOnly', val => {
      Object.keys(this.shareList).forEach(rtilCode => {
        if (this.State.audioType) {
          if (this.State.audioType == 2) {
            this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[rtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', false);
              this.channels[rtilCode].hasUnsubscribe = true;
            }
          }
        } else {
          if (!this.State.inAudioOnlyStatus) {
            this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[rtilCode].hasUnsubscribe = false;
          } else {
            if (val) {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', true);
              this.channels[rtilCode].hasUnsubscribe = false;
            } else {
              this.dealLocalShareScreen(rtilCode, 'needControlPlay', 'unExecuteCallback', false);
              this.channels[rtilCode].hasUnsubscribe = true;
            }
          }
        }
      });
    });
    // co-host
    Bus.$on('collaborateInvite', result => {
      const {
        collaborateUserId,
        status,
        PartyCode
      } = result;
      if (collaborateUserId == this.State.loginInfo.id && PartyCode) {
        status === 0 ? this.coHostInfo.show = true : this.coHostInfo.show = false;
        if (status === 0) {
          this.coHostInfo.info = result;
        } else if (status === 2) {
          this.coHostInfo.info = {};
        }
      }
    });
    Bus.$on('collaborateInvite', result => {
      if (!result.PartyCode) {
        const {
          collaborateUserId,
          status
        } = result;
        if (collaborateUserId == this.State.loginInfo.id) {
          status === 0 ? this.collaborateInfo.show = true : this.collaborateInfo.show = false;
          if (status === 0) {
            this.collaborateInfo.info = result;
          } else if (status === 2) {
            this.collaborateInfo.info = {};
          }
        }
      }
    });
    Bus.$on('setAudioMatrix', val => {
      this.settingPopupInfo.show = val;
      if (val) {
        setTimeout(() => {
          Bus.$emit('getAllParticipantInfo', 'notNeedJudge');
        });
      }
    });
  },
  mounted() {
    window.addEventListener('resize', () => {
      if (this.resizeTimer) clearTimeout(this.resizeTimer);
      this.resizeTimer = setTimeout(() => {
        // 避免dom结构一直渲染，只执行最后一次
        this.changeLayout();
      }, 100);
    });
    if (!this.State.volumeBar) {
      this.State.volumeBar = new VolumeBar();
    }
  },
  methods: {
    addRtcEventListener() {
      this.newRtc.on('autoPlayFailed', this.dealAutoPlayFailed);
      this.newRtc.on('cameraChange', this.dealCameraChange);
      this.newRtc.on('microphonesChange', this.dealMicrophonesChange);
      this.newRtc.on('playbackChange', this.dealPlaybackChange);
    },
    dealAutoPlayFailed() {
      this.$confirm(this.$t('commonFunction.autoPlayFailed'), {
        confirmButtonText: this.$t('galleryHost.ok'),
        cancelButtonText: this.$t('commonFunction.cancel'),
        customClass: 'confirmBox',
        cancelButtonClass: 'cancelBtn',
        confirmButtonClass: 'joinBtn'
      }).then(() => {
        this.rtc && this.rtc.rePlay();
      });
    },
    dealCameraChange(switchInfo) {
      const {
        result,
        cameraList,
        deviceId
      } = switchInfo;
      this.devicesInfo.cameraList = cameraList;
      if (result === 'success') {
        this.devicesInfo.cameraId = deviceId;
        handleLocalStorage('set', 'cameraId', deviceId);
        this.$message.success(this.$t('common.autoSwitchNewCameraSuccess'));
      } else if (result === 'failed') {
        this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
      }
    },
    dealMicrophonesChange(switchInfo) {
      const {
        result,
        microphoneList,
        deviceId
      } = switchInfo;
      this.devicesInfo.microphoneList = microphoneList;
      if (result === 'success') {
        this.detecteMicMuted();
        this.$refs.pipBox.reUseAudioWorklet();
        this.devicesInfo.microphoneId = deviceId;
        handleLocalStorage('set', 'microphoneId', deviceId);
        this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
      } else if (result === 'failed') {
        this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
      }
    },
    async dealPlaybackChange(changeDevice) {
      if (!this.newRtc) return;
      if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
        this.$t('common.notSupportSwitchSpeaker');
        return;
      }
      const {
        speakerList
      } = await this.rtc.getPalybackDevices();
      this.devicesInfo.speakerList = speakerList;
      const {
        state,
        device
      } = changeDevice;
      // 拔掉当前正在使用的设备
      if (state === 'INACTIVE' && this.devicesInfo.speakerId === device.deviceId) {
        if (!speakerList.length) return;
        const newDevice = speakerList.find(item => item.deviceId === 'default') || speakerList[0];
        const newDeviceId = newDevice.deviceId;
        handleLocalStorage('set', 'speakerId', newDeviceId);
        this.devicesInfo.speakerId = newDeviceId;
        this.$nextTick(this.updateSpeakerComponents.bind(this));
      } else if (changeDevice.state === 'ACTIVE' && this.devicesInfo.speakerId == 'default') {
        // 如果当前使用的是 default 设备并且新加入的也是 default 设备，则切换到最新的 default 设备
        const {
          groupId
        } = device;
        const newDeviceIsDefault = speakerList.find(item => item.groupId === groupId && item.deviceId === 'default');
        if (newDeviceIsDefault !== null && newDeviceIsDefault !== void 0 && newDeviceIsDefault.deviceId) {
          handleLocalStorage('set', 'speakerId', 'default');
          this.$nextTick(this.updateSpeakerComponents.bind(this));
        }
      }
    },
    updateSpeakerComponents() {
      const array = Object.keys(this.channels).filter(rtilCode => {
        return rtilCode != this.userInfo.rtilCode;
      });
      array.forEach(rtilCode => {
        if (this.channels[rtilCode].audioTrack) {
          var _this$channels$rtilCo, _this$channels$rtilCo2;
          (_this$channels$rtilCo = (_this$channels$rtilCo2 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo === void 0 ? void 0 : _this$channels$rtilCo.call(_this$channels$rtilCo2, currentSpeakerList[0].deviceId);
        }
      });
    },
    wsAddEventListener() {
      wsDispatcher.register('startStt', this.startStt, 'pStartStt');
      wsDispatcher.register('stopStt', this.stopStt, 'pStoptStt');
      wsDispatcher.register('setTalkBack', this.setTalkBack, 'pSetTalkBack');
      wsDispatcher.register('cancelTalkBack', this.cancelTalkBack, 'pCancelTalkBack');
      wsDispatcher.register('endParty', this.dealEndParty, 'pEndParty');
      wsDispatcher.register('rtilLiveStatus', this.dealRtilLiveStatus, 'pRtilStatus');
      wsDispatcher.register('flipVideo', this.dealFlipVideo, 'pFlipVideo');
      wsDispatcher.register('setParticipantTalkBack', this.dealParticipantTalkBack, 'pTalkBack');
      wsDispatcher.register('cancelParticipantTalkBack', this.dealCancelParticipantTalkBack, 'CancelPTalkBack');
      wsDispatcher.register('setOutput', this.dealSetOutput, 'pSetOutput');
      wsDispatcher.register('cancelOutput', this.dealCancelOutput, 'pCancelOutput');
      wsDispatcher.register('viewPositionV2', this.dealViewPositionV2, 'pViewPositionV2');
      wsDispatcher.register('setBehaviors', this.dealSetBehaviors, 'pSetBehaviors');
      wsDispatcher.register('controlBehavior', this.dealControlBehavior, 'pControlBehavior');
      wsDispatcher.register('moveParticipants', this.dealMoveParticipants, 'pMoveParticipants');
      wsDispatcher.register('removeParticipant', this.dealRemoveParticipant, 'pRemoveParticipant');
      wsDispatcher.register('intercom', this.dealIntercom, 'pIntercom');
      wsDispatcher.register('videoQuality', this.dealVideoQuality, 'pVideoQuality');
      wsDispatcher.register('startPrivateConversation', this.dealPrivateConversation, 'pStartPrivateConversation');
      wsDispatcher.register('cancelPrivateConversation', this.dealCancelPrivateConversation, 'pCancelPrivateConversation');
      wsDispatcher.register('notify', this.dealNotify, 'pNotify');
      wsDispatcher.register('button', this.dealButton, 'pButton');
      wsDispatcher.register('audioOn', this.dealAudioOn, 'pAudioON');
      wsDispatcher.register('audioOff', this.dealAudioOff, 'pAudioOFF');
      wsDispatcher.register('talkOn', this.dealTalkOn, 'pTalkON');
      wsDispatcher.register('talkOff', this.dealTalkOff, 'pTalkOFF');
      wsDispatcher.register('pushToTalk', this.dealPushToTalk, 'hostPushToTalk');
      wsDispatcher.register('startVoip', this.dealStartVoIP, 'pStartVoIP');
      wsDispatcher.register('stopVoip', this.dealStopVoIP, 'pStopVoIP');
    },
    startStt(result) {
      const {
        outputRtilCode
      } = result;
      if (this.State.showChatMessage) {
        this.State.showChatMessage = false;
        this.$nextTick(() => {
          this.changeLayout();
        });
      }
      this.showAISpeech = true;
      this.State.showAISpeech = true;
      this.sttRtilCode = outputRtilCode;
      this.rtilCodeList = this.rtilCodeList.filter(v => v != outputRtilCode);
      this.allPartyMembers = this.allPartyMembers.filter(v => v != outputRtilCode);
      this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != outputRtilCode);
      this.State.allRtilCodeArray = this.State.allRtilCodeArray.filter(v => v != outputRtilCode);
    },
    stopStt() {
      this.sttRtilCode = '';
      this.showAISpeech = false;
      this.State.showAISpeech = false;
    },
    setTalkBack(result) {
      if (result.partyCode == this.userInfo.joinCode) {
        this.talkbackStatus = true;
        this.State.talkbackStatus = true;
      }
    },
    cancelTalkBack(result) {
      if (result.partyCode == this.userInfo.joinCode) {
        this.talkbackStatus = false;
        this.State.talkbackStatus = false;
      }
    },
    dealEndParty() {
      this.shareClient && this.cancelStopShare();
      this.State.partyJoinInfo.behavior.enableControlMedia = 'false';
      routerJump('remove', {
        type: 'end'
      });
    },
    dealRtilLiveStatus(result) {
      this.rtilStatusObj = result;
    },
    dealFlipVideo(result) {
      this.$set(this.degreeHost, result.rtilCode, result.degree);
    },
    dealParticipantTalkBack(result) {
      const {
        rtilCode
      } = result;
      this.$set(this.talkBackInfo, rtilCode, true);
      this.$set(this.controlMuteInfo, rtilCode, true);
      if (rtilCode == this.userInfo.rtilCode) {
        this.$message.success(this.$t('commonSetting.onLocalLazyAUdioTip'));
      }
    },
    dealCancelParticipantTalkBack(result) {
      const {
        rtilCode
      } = result;
      this.$set(this.talkBackInfo, rtilCode, false);
      this.$set(this.controlMuteInfo, rtilCode, '');
      if (rtilCode == this.userInfo.rtilCode) {
        this.$message.success(this.$t('commonSetting.offLocalLazyAUdioTip'));
      }
    },
    dealSetOutput(result) {
      const {
        rtilCode
      } = result;
      this.outputRtilCode = rtilCode;
      this.State.outputCode = rtilCode;
      this.largeScreenRtilCode = rtilCode;
      if (this.outputRtilCode == this.userInfo.rtilCode) {
        this.$nextTick(() => {
          this.channels[rtilCode] = {
            ...this.channels[rtilCode],
            ...result
          };
        });
      }
      this.$set(this.rtilCodeKeyTypeVal, rtilCode, 'Manwindow');
      this.handleRtilCodeList();
    },
    dealCancelOutput(result) {
      const {
        rtilCode
      } = result;
      if (this.outputRtilCode == this.userInfo.rtilCode) {
        setTimeout(async () => {
          var _this$rtc2, _this$rtc3, _this$rtc3$_localVide;
          if ((_this$rtc2 = this.rtc) !== null && _this$rtc2 !== void 0 && _this$rtc2._localAudioTrack) {
            try {
              await this.rtc._localAudioTrack.stop();
            } catch (e) {
              console.log('stop localAudio failed');
            }
          }
          (_this$rtc3 = this.rtc) === null || _this$rtc3 === void 0 ? void 0 : (_this$rtc3$_localVide = _this$rtc3._localVideoTrack) === null || _this$rtc3$_localVide === void 0 ? void 0 : _this$rtc3$_localVide.play('local_stream');
        }, 100);
      }
      if (rtilCode == this.userInfo.rtilCode) {
        var _this$$refs$pipBox;
        (_this$$refs$pipBox = this.$refs.pipBox) === null || _this$$refs$pipBox === void 0 ? void 0 : _this$$refs$pipBox.changeFullScreenVal(false);
      }
      if (this.outputRtilCode == rtilCode) {
        this.outputRtilCode = '';
        this.State.outputCode = '';
      }
      if (this.outputRtilCode == rtilCode && this.outputRtilCode == this.largeScreenRtilCode) {
        this.largeScreenRtilCode = '';
      }
      this.handleRtilCodeList();
    },
    dealViewPositionV2(result) {
      const rtilCodes = result.total;
      this.allRtilList = rtilCodes;
      this.handleRtilCodeList();
      rtilCodes.forEach(rtilCode => {
        const haveName = this.behaviorInfo[rtilCode];
        if (!haveName) this.getNickName(rtilCode);
      });
    },
    dealSetBehaviors(result) {
      const behaviors = result.behaviors;
      behaviors.forEach(val => {
        if (val.key == 'nickName') {
          if (!val.value.includes('_Screen_Share')) {
            this.$set(this.behaviorInfo, val.mark, val.value);
            this.$set(this.State.globalNameInfo, val.mark, val.value);
            // firstName获取不到，说明未登录头像要跟nickName着变化
            if (this.isNotLoginArray.includes(val.mark)) {
              this.$set(this.avatarInfo, val.mark, val.value);
            }
          }
          Object.keys(this.shareList).forEach(share => {
            if (this.shareList[share] == val.mark) {
              if (!val.value.includes('_Screen_Share')) {
                this.$set(this.behaviorInfo, share, val.value);
                this.$set(this.State.globalNameInfo, share, val.value);
              }
              this.saveShareName({
                rtilCode: share
              });
            }
          });
          if (val.initiator && val.initiator != this.userInfo.rtilCode && val.mark == this.userInfo.rtilCode) {
            this.$message.success(this.$t('remainWords.hostModifyParticipantName'));
          }
        }
        if (val.key == 'voiceCommand') {
          const isAdd = val.value === 'true';
          const curentRtilCode = Number(val.mark);
          if (isAdd) {
            this.State.voiceCommandList.push(curentRtilCode);
          } else {
            this.State.voiceCommandList = this.State.voiceCommandList.filter(rtilCode => {
              return rtilCode != curentRtilCode;
            });
          }
        }
      });
    },
    async dealControlBehavior(result) {
      const {
        rtilCode,
        behavior,
        senderRtilCode
      } = result;
      const {
        key,
        value
      } = behavior;
      const changeToBooleanVal = value === 'true';
      if (rtilCode == this.userInfo.rtilCode) {
        if (key == 'camera') {
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'camera', senderRtilCode);
          if (!changeToBooleanVal) {
            controlCamera(this.rtc, this.devicesInfo, changeToBooleanVal, result => {
              if (result === 'failed') {
                this.$message.warning(this.$t('common.hostOperationCameraFailed'));
                // 操作失败，给host发送消息
                this.sendToHost('camera', 3);
              }
            });
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'camera',
              value: value === 'true',
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost'
            });
            this.$message.warning(this.$t('commonFunction.hasCameraOff'));
          } else {
            this.CameraTips.hideSave = false;
            this.CameraTips.hideCancel = false;
            this.CameraTips.showGotIt = false;
            this.CameraTips.show = true;
            this.CameraTips.content = `<div class="end">${this.$t('galleryParticipant.cameraTipCon')}</div>`;
          }
        }
        if (key == 'mic') {
          var _this$rtc4;
          // 避免之后多host控制与会者device，用于记录操作host的rtilCode，以最后一次操作的host为准
          this.$set(this.hostControlPipRtilCode, 'mic', senderRtilCode);
          let operationResult = 'success';
          if ((_this$rtc4 = this.rtc) !== null && _this$rtc4 !== void 0 && _this$rtc4._localAudioTrack && this.rtcLoaded) {
            const type = changeToBooleanVal ? 'publish' : 'unpublish';
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, changeToBooleanVal, result => {
              if (result != 'failed' && changeToBooleanVal) {
                var _this$rtc5;
                // 为了可以听见自己声音的功能添加的
                if (this.State.startHearSelf && this.hearSelf && (_this$rtc5 = this.rtc) !== null && _this$rtc5 !== void 0 && _this$rtc5._localAudioTrack) {
                  this.rtc.play(this.rtc._localAudioTrack, '', {
                    type: 'audio'
                  });
                }
              } else {
                operationResult = 'failed';
              }
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: changeToBooleanVal,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost'
            });
          } else {
            this.$message.warning(this.$t('common.hostOperationMicroFailed'));
            // 操作失败，给host发送消息
            this.sendToHost('mic', 3);
          }
          this.$message.warning(changeToBooleanVal ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'));
        }
      }
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
        // firstName获取不到，说明未登录头像要跟nickName着变化
        const _rtilCode = rtilCode + '';
        if (this.isNotLoginArray.includes(_rtilCode)) {
          this.avatarInfo[rtilCode] = value;
        }
      }
    },
    dealMoveParticipants(result) {
      if (this.userInfo.joinCode != result.originCode) return; // 如果在move过程中，这个与会者到了别的party。则move的命令此时不作处理
      result.rtilCodes.forEach(v => {
        if (v == this.userInfo.rtilCode) {
          routerJump('participate', {
            join_id: result.targetCode,
            moveParticipants: true
          });
        }
      });
    },
    dealRemoveParticipant(result) {
      if (result.rtilCode === this.rtilCode) routerJump('remove');
    },
    dealIntercom(result) {
      const {
        partyCode,
        rtilCode,
        receiveRtilCode,
        startRtilCode,
        msg,
        value
      } = result;
      const {
        ack
      } = msg;
      if (value === 'true') {
        if (this.State.startPrivateInfo[rtilCode]) {
          if (!this.State.startPrivateInfo[rtilCode].includes(receiveRtilCode)) this.State.startPrivateInfo[rtilCode].push(receiveRtilCode);
        } else {
          this.$set(this.State.startPrivateInfo, rtilCode, [receiveRtilCode]);
        }
        if (startRtilCode && startRtilCode == this.userInfo.rtilCode && !this.State.localSendPrivateArray.includes(receiveRtilCode)) {
          this.State.localSendPrivateArray.push(receiveRtilCode);
        }
        if (receiveRtilCode == this.rtilCode) {
          if (!this.sendPrivateToMeRtilcodes.includes(startRtilCode)) this.sendPrivateToMeRtilcodes.push(startRtilCode);
          const nickName = this.behaviorInfo[rtilCode] ? this.behaviorInfo[rtilCode] : '';
          if (startRtilCode && ack === 0) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.receiveTwoWayPrivate', {
                nickName
              })
            });
            this.privateConversationFn({
              rtilCode: rtilCode,
              channel: partyCode,
              type: 'startPrivateConversation',
              receive: true,
              ack: 1
            });
          } else {
            if (ack === 0) {
              this.$message({
                type: 'success',
                message: this.$t('commonPartyHost.receiveOneWayPrivate', {
                  nickName
                })
              });
            }
          }
        }
      } else {
        if (startRtilCode && startRtilCode == this.userInfo.rtilCode && this.State.localSendPrivateArray.includes(receiveRtilCode)) {
          this.State.localSendPrivateArray = this.State.localSendPrivateArray.filter(rtilCode => rtilCode != receiveRtilCode);
        }
        if (this.State.startPrivateInfo[rtilCode]) {
          this.State.startPrivateInfo[rtilCode] = this.State.startPrivateInfo[rtilCode].filter(rtilCode => {
            return rtilCode != receiveRtilCode;
          });
          if (receiveRtilCode === this.rtilCode) {
            const nickName = this.behaviorInfo[rtilCode];
            // 如果是私聊发起者取消私聊，那么接收者也要取消私聊
            if (this.sendPrivateToMeRtilcodes.includes(rtilCode) && ack === 0) {
              this.sendPrivateToMeRtilcodes = this.sendPrivateToMeRtilcodes.filter(rtilCodes => rtilCodes != rtilCode);
              this.privateConversationFn({
                rtilCode: rtilCode,
                channel: partyCode,
                type: 'cancelPrivateConversation',
                receive: true,
                ack: 1
              });
              this.$message({
                type: 'success',
                message: this.$t('commonPartyHost.cancelTwoWayPrivate', {
                  nickName
                })
              });
            } else {
              if (ack === 0) {
                this.$message({
                  type: 'success',
                  message: this.$t('commonPartyHost.cancelOneWayPrivate', {
                    nickName
                  })
                });
              } else {
                this.$message({
                  type: 'success',
                  message: this.$t('commonPartyHost.endTwoWayPrivate', {
                    nickName
                  })
                });
              }
            }
          }
          // 删除发起者数据
          if (this.State.startPrivateInfo[rtilCode] && !this.State.startPrivateInfo[rtilCode].length) this.$delete(this.State.startPrivateInfo, rtilCode);
        }
      }
    },
    dealVideoQuality(result) {
      this.getRtcStats(result);
    },
    dealPrivateConversation(result) {
      const {
        rtilCode,
        crewRtilCode
      } = result;
      if (rtilCode === this.rtilCode || crewRtilCode == this.rtilCode) {
        var _this$myselfMuteInfo$, _this$myselfMuteInfo$2;
        if (rtilCode === this.rtilCode) {
          this.$message({
            type: 'success',
            message: 'Production Crew has set up a private conversation with you.'
          });
        }
        // 如果之前因为 Audio Matrix 静音，那么开启私聊时需要恢复，然后再取消私聊时在静音
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && (_this$myselfMuteInfo$ = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$ !== void 0 && _this$myselfMuteInfo$.includes(crewRtilCode)) {
          this.myselfMuteInfo.muteRtilCodes = this.myselfMuteInfo.muteRtilCodes.filter(rtilCode => {
            return rtilCode != crewRtilCode;
          });
          this.$set(this.channels[crewRtilCode], 'muteByAudioMatrix', false);
          this.rtc.subscribe(crewRtilCode, 'audio');
        }
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && (_this$myselfMuteInfo$2 = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$2 !== void 0 && _this$myselfMuteInfo$2.includes(rtilCode)) {
          this.myselfMuteInfo.muteRtilCodes = this.myselfMuteInfo.muteRtilCodes.filter(rtilCode => {
            return rtilCode != result.rtilCode;
          });
          this.$set(this.channels[rtilCode], 'muteByAudioMatrix', false);
          this.rtc.subscribe(rtilCode, 'audio');
        }
      }
    },
    async dealCancelPrivateConversation(result) {
      const {
        rtilCode,
        crewRtilCode,
        origin
      } = result;
      if (rtilCode === this.rtilCode || crewRtilCode == this.rtilCode) {
        var _this$myselfMuteInfo$3, _this$myselfMuteInfo$4;
        if (rtilCode === this.rtilCode) {
          this.$message({
            type: 'success',
            message: this.$t('galleryParticipant.privateConversaitonEnd')
          });
        }
        await this.getMyselfMuteInfo({
          realPartyCode: this.partyCode,
          rtilCode: this.rtilCode
        });
        // 如果之前 Audio Matrix 静音，因为开启私聊时恢复，那么取消私聊时应该恢复静音
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && (_this$myselfMuteInfo$3 = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$3 !== void 0 && _this$myselfMuteInfo$3.includes(crewRtilCode)) {
          this.$set(this.channels[crewRtilCode], 'muteByAudioMatrix', true);
          this.rtc.unsubscribe(crewRtilCode, 'audio');
        }
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && (_this$myselfMuteInfo$4 = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$4 !== void 0 && _this$myselfMuteInfo$4.includes(rtilCode)) {
          this.$set(this.channels[rtilCode], 'muteByAudioMatrix', true);
          this.rtc.unsubscribe(rtilCode, 'audio');
        }
        if (origin === 'setParticipantTalkBack') {
          this.$message.warning(this.$t('common.stopPrivateByTalkback'));
        }
      }
    },
    dealNotify(result) {
      const {
        rtilCode,
        origin,
        key
      } = result;
      if (origin == 'host' && rtilCode == this.userInfo.rtilCode) {
        if (key == 'getMediaInfo') {
          this.sendMediaInfoToHost(rtilCode);
        } else if (key === 'changeParticipantMedia') {
          this.controlMediaInfo.info = result;
          if (this.State.partyJoinInfo.behavior.enableControlMedia === 'true') {
            this.controlModify(true);
          } else {
            this.controlMediaInfo.show = true;
          }
        }
      }
    },
    async dealButton(result) {
      const {
        buttonType,
        operationType
      } = result.buttonStatus;
      if (buttonType === 4) {
        if (operationType === 0) {
          this.lockName = true;
          this.$message.success(this.$t('remainWords.hostLockParticipantName'));
        } else {
          this.lockName = false;
          this.$message.success(this.$t('remainWords.hostUnlockParticipantName'));
        }
      } else if (buttonType === 6) {
        var _this$rtc6;
        if (operationType === 1 && (_this$rtc6 = this.rtc) !== null && _this$rtc6 !== void 0 && _this$rtc6._localAudioTrack) {
          this.startHearSelf = true;
          this.iconList.forEach(item => {
            if (item === 'speaker') {
              this.iconList.push('hearMyself');
            }
          });
          if (this.hearSelf && !this.State.isMute && this.State.micStatus[this.userInfo.rtilCode]) {
            var _this$rtc7;
            (_this$rtc7 = this.rtc) === null || _this$rtc7 === void 0 ? void 0 : _this$rtc7.play(this.rtc._localAudioTrack, '', {
              type: 'audio'
            });
          }
        } else {
          var _this$rtc8;
          this.startHearSelf = false;
          this.iconList.forEach((item, index) => {
            if (item === 'hearMyself') {
              this.iconList.splice(index, 1);
            }
          });
          (_this$rtc8 = this.rtc) === null || _this$rtc8 === void 0 ? void 0 : _this$rtc8.stop(this.rtc._localAudioTrack);
          this.saveHearSelfBehavior(false);
        }
      } else if (buttonType === 7) {
        if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
        if (operationType) {
          this.hadOpenWebCloud = true;
          if (this.rtc) await this.rtc.leave();
          this.userInfo.status.cloudProxy = 1;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam, 'notInitStatus');
        } else {
          this.hadOpenWebCloud = false;
          this.rtc && (await this.rtc.leave('closeCLoudProxy'));
          this.userInfo.status.cloudProxy = 0;
          this.joinAgoraClient(this.userInfo, this.userInfo.behavior, this.joinParam, 'notInitStatus');
        }
      } else if (buttonType === 9) {
        this.State.startPrivateInfo = {};
        this.State.audioMatrixEnable = operationType;
        if (!operationType) this.settingPopupInfo.show = false; // 不想开启时与会者这边自动弹框
        this.controlAudioMatrix(operationType);
      } else if (buttonType === 10) {
        Bus.$emit('changeAudioMatrix', {
          host: this.State.audioMatrixEnable,
          participant: operationType
        });
        this.controlAudioMatrix(operationType);
      } else if (buttonType === 12) {
        this.intercom = operationType;
        this.State.intercom = operationType;
        // 如果关闭私聊功能需要把除了 host 之外的私聊状态都清除掉
        if (!operationType) {
          Object.keys(this.State.startPrivateInfo).forEach(rtilCode => {
            if (this.channels[rtilCode] && this.channels[rtilCode].audioTrack) {
              this.rtc.play(this.channels[rtilCode].audioTrack, '', {
                type: 'audio'
              });
            }
            this.$delete(this.State.startPrivateInfo, rtilCode);
          });
          this.$message.success(this.$t('commonFunction.disableIntercom'));
        } else {
          this.$message.success(this.$t('commonFunction.enableIntercom'));
        }
      } else if (buttonType === 13) {
        if (this.State.micStatus[this.userInfo.rtilCode]) {
          var _this$rtc9;
          this.$message.warning(this.$t('setting.muteAllParticipantsTips'));
          if ((_this$rtc9 = this.rtc) !== null && _this$rtc9 !== void 0 && _this$rtc9._localAudioTrack) {
            const result = await controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
            if (result === 'success') this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          }
        }
      } else if (buttonType === 14) {
        this.State.aiBotEnable = operationType;
      } else if (buttonType === 15) {
        this.State.pushToTalk = operationType;
        if (operationType === 1) {
          this.getAllGroup();
          this.State.pushTalkOpen = true;
        } else {
          this.State.groupList = [];
          this.State.pressShortCut = 0;
          this.State.shortCutArray = {};
          this.State.currentPushTalkInfo = {};
          this.State.pushTalkOpen = false;
        }
      } else if (buttonType === 16 || buttonType === 20) {
        if (buttonType === 20) {
          if (operationType == 1) {
            this.muteAmAudio = true;
          } else {
            this.muteAmAudio = false;
          }
        }
        this.State.participantPushTalkOpen = operationType;
        if (operationType === 1) {
          this.getAllGroup();
        } else {
          this.State.groupList = [];
          this.State.pressShortCut = 0;
          Object.keys(this.State.currentPushTalkInfo).forEach(key => {
            const isTalk = this.State.currentPushTalkInfo[key].talk;
            const hostRtilCodes = this.userInfo.managerRtils;
            if (isTalk && !hostRtilCodes.includes(this.userInfo.rtilCode)) {
              this.State.currentPushTalkInfo[key].talk = false;
            }
          });
          console.log('track', this.State.currentPushTalkInfo);
        }
      } else if (buttonType === 17) {
        if (operationType === 0) {
          this.audioLevel = true;
          this.$message.success(this.$t('remainWords.hostChangeAudioLevel'));
        } else {
          this.audioLevel = false;
          this.$message.success(this.$t('remainWords.hostChangeAudioBar'));
        }
      }
    },
    dealAudioOn(result) {
      const {
        rtilCode,
        muteRtilCode
      } = result;
      const _this = this;
      // 更新所有 Audio Matrix 信息
      if (this.State.matrixInfoMuteMap[rtilCode]) {
        const array = this.State.matrixInfoMuteMap[rtilCode].filter(rtilCode => {
          return rtilCode != muteRtilCode;
        });
        this.$set(this.State.matrixInfoMuteMap, rtilCode, array);
      }
      if (rtilCode == this.rtilCode) {
        if (this.channels[muteRtilCode]) {
          // 如果这个与会者没有和自己 talk 仍然保留 mute
          if (!this.State.matrixInfoUnTalkMap[muteRtilCode] || !this.State.matrixInfoUnTalkMap[muteRtilCode].includes(rtilCode)) {
            if (_this.myselfMuteInfo.muteRtilCodes) {
              _this.myselfMuteInfo.muteRtilCodes = _this.myselfMuteInfo.muteRtilCodes.filter(rtilCode => {
                return rtilCode != muteRtilCode;
              });
            }
          }
          this.$set(this.channels[muteRtilCode], 'muteByAudioMatrix', false);
          // 根据最新逻辑还要判断对面是否和和你 talk 了
          if (!this.State.matrixInfoUnTalkMap[muteRtilCode] || !this.State.matrixInfoUnTalkMap[muteRtilCode].includes(rtilCode)) {
            this.rtc.subscribe(muteRtilCode, 'audio');
          }
        }
      }
    },
    dealAudioOff(result) {
      const {
        rtilCode,
        muteRtilCode
      } = result;
      const _this = this;
      if (this.State.matrixInfoMuteMap && this.State.matrixInfoMuteMap[rtilCode]) {
        this.State.matrixInfoMuteMap[rtilCode].push(muteRtilCode);
        this.$set(this.State.matrixInfoMuteMap, rtilCode, this.State.matrixInfoMuteMap[rtilCode]);
      } else {
        this.$set(this.State.matrixInfoMuteMap, rtilCode, [muteRtilCode]);
      }
      if (rtilCode == this.rtilCode) {
        if (_this.channels[muteRtilCode]) {
          var _this$myselfMuteInfo$5, _this$rtc10;
          (_this$myselfMuteInfo$5 = this.myselfMuteInfo.muteRtilCodes) === null || _this$myselfMuteInfo$5 === void 0 ? void 0 : _this$myselfMuteInfo$5.push(muteRtilCode);
          this.$set(this.channels[muteRtilCode], 'muteByAudioMatrix', true);
          (_this$rtc10 = this.rtc) === null || _this$rtc10 === void 0 ? void 0 : _this$rtc10.unsubscribe(muteRtilCode, 'audio');
        }
      }
    },
    dealTalkOn(result) {
      const {
        rtilCode,
        targetRtilCode
      } = result;
      if (this.State.matrixInfoUnTalkMap[rtilCode]) {
        const array = this.State.matrixInfoUnTalkMap[rtilCode].filter(rtilCode => {
          return rtilCode != targetRtilCode;
        });
        this.$set(this.State.matrixInfoUnTalkMap, rtilCode, array);
      }
      if (targetRtilCode == this.rtilCode) {
        if (this.channels[rtilCode]) {
          // 如果这个与会者没有和自己 talk 仍然保留 mute
          if (!this.State.matrixInfoMuteMap[targetRtilCode] || !this.State.matrixInfoMuteMap[targetRtilCode].includes(rtilCode)) {
            var _this$myselfMuteInfo$6;
            this.myselfMuteInfo.muteRtilCodes = (_this$myselfMuteInfo$6 = this.myselfMuteInfo.muteRtilCodes) === null || _this$myselfMuteInfo$6 === void 0 ? void 0 : _this$myselfMuteInfo$6.filter(rtilCodes => {
              return rtilCodes != rtilCode;
            });
          }
        }
      }
    },
    dealTalkOff(result) {
      const {
        rtilCode,
        targetRtilCode
      } = result;
      if (this.State.matrixInfoUnTalkMap[rtilCode]) {
        this.State.matrixInfoUnTalkMap[rtilCode].push(targetRtilCode);
        this.$set(this.State.matrixInfoUnTalkMap, rtilCode, this.State.matrixInfoUnTalkMap[rtilCode]);
      } else {
        this.$set(this.State.matrixInfoUnTalkMap, rtilCode, [targetRtilCode]);
      }
      if (targetRtilCode == this.rtilCode) {
        if (this.channels[rtilCode] && this.myselfMuteInfo.muteRtilCodes) {
          this.myselfMuteInfo.muteRtilCodes.push(rtilCode);
        }
      }
    },
    dealPushToTalk(result) {
      this.$set(this.State.currentPushTalkInfo, result.id, result);
    },
    dealStartVoIP(result) {
      if (result.rtilCode == this.rtilCode) this.selectRid = result.rid;
    },
    dealStopVoIP(result) {
      // 判断 val 是因为存在定时任务返回为空的情况
      if (result && result.rtilCode == this.rtilCode) this.selectRid = '';
    },
    dealLocalShareScreen(rtilCode, needControlPlay, unExecuteCallback, val) {
      if (!this.rtc) return;
      // 先判断是否有自己分享的视频
      if (JSON.stringify(this.State.localShareInfo) == '{}' || !this.State.localShareInfo[rtilCode]) {
        val ? this.rtc.subscribe(rtilCode, 'video', unExecuteCallback) : this.rtc.unsubscribe(rtilCode, 'video', unExecuteCallback);
      } else {
        // 如果有自己分享的视频，再去比较当前的 rtilCode 是否是分享视频的 rtilCode
        if (this.State.localShareInfo[rtilCode]) {
          if (!needControlPlay) return;
          if (rtilCode == this.outputRtilCode) {
            var _this$$refs$mainwindo;
            (_this$$refs$mainwindo = this.$refs.mainwindowBox) === null || _this$$refs$mainwindo === void 0 ? void 0 : _this$$refs$mainwindo.controlLocalSharePlay(rtilCode, val);
          } else {
            this.$refs[`remoteSource${rtilCode}`] && this.$refs[`remoteSource${rtilCode}`][0] && this.$refs[`remoteSource${rtilCode}`][0].controlLocalSharePlay(rtilCode, val);
          }
        }
      }
    },
    detecteMicMuted() {
      var _this$rtc11, _this$rtc11$_localAud;
      const mediaStream = (_this$rtc11 = this.rtc) === null || _this$rtc11 === void 0 ? void 0 : (_this$rtc11$_localAud = _this$rtc11._localAudioTrack) === null || _this$rtc11$_localAud === void 0 ? void 0 : _this$rtc11$_localAud._mediaStreamTrack;
      if (!mediaStream) return;
      this.osLevelmicMuted = mediaStream.muted;
      mediaStream.onmute = () => {
        this.osLevelmicMuted = true;
      };
      mediaStream.onunmute = () => {
        this.osLevelmicMuted = false;
      };
    },
    openMicMuted() {
      window.open('ms-settings:sound', '_blank');
    },
    notRemind(val) {
      this.checkRemindMe = val;
      handleLocalStorage('set', `aiPolicyNotShown_${handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime()}`, val);
    },
    getHistoryData(info) {
      this.axios.get(`/partyline-backend/stt/transcript/noLogin/q?partyCode=${info.joinCode}`).then(res => {
        if (res.data.errorCode === '0x0') {
          const data = res.data.result;
          if (data && data.length > 0) {
            const array = [];
            data.forEach((item, index) => {
              const decodedBytes = atob(item.text);
              const utf8Decoder = new TextDecoder();
              const originalContent = utf8Decoder.decode(new Uint8Array(decodedBytes.split('').map(char => char.charCodeAt(0))));
              const obj = {
                uid: item.rtilCode,
                content: originalContent,
                time: item.endTime
              };
              if (index == data.length - 1) {
                obj.showDivider = true;
              }
              this.$set(this.behaviorInfo, item.rtilCode, item.nickName);
              array.push(obj);
            });
            this.sttHistoryList = array;
          }
        }
      });
    },
    sendTranslate() {
      if (!this.State.summaryInfo.contentText) return;
      changeBehaviorStatus({
        key: 'summaryLanguage',
        rtilCode: this.userInfo.rtilCode,
        realPartyCode: this.userInfo.realPartyCode,
        value: this.translateInto || ''
      });
      this.$refs.aiSpeech && this.$refs.aiSpeech.createSummary(this.translateInto);
    },
    listenerKeyDown(event, item) {
      if (event.repeat) return;
      // 如果是来自INPUT, TEXTAREA或内容可编辑的元素，直接返回，不处理
      if (['INPUT', 'TEXTAREA'].includes(event.target.tagName) || event.target.isContentEditable) {
        return;
      }
      // 单声道直播
      if (!item && event !== null && event !== void 0 && event.ctrlKey && (event === null || event === void 0 ? void 0 : event.keyCode) === 76) {
        if (this.$refs.pipBox && this.talkbackStatus) {
          if (this.talkBackInfo[this.userInfo.rtilCode]) {
            this.setTalkback();
          } else {
            if (this.rtilStatusObj[this.userInfo.rtilCode] && this.rtilStatusObj[this.userInfo.rtilCode].peerId.includes('fffff')) {
              this.$message.error(this.$t('addWords.failToTalkBack'));
              return;
            }
            this.setTalkback();
          }
        }
        window.event.preventDefault();
      }
      let currentGroup = '';
      if (item) {
        currentGroup = item.key;
      } else {
        Object.keys(this.State.shortCutArray).forEach(key => {
          if (key == Number(event.key) && !event.ctrlKey && !event.altKey && !event.shiftKey) {
            currentGroup = Number(event.key);
          }
        });
      }
      if (this.State.pressShortCut && this.State.pressShortCut != currentGroup) {
        this.$message.error(this.$t('common.pushTalkOnlyOne'));
        return;
      }
      const currentTime = Date.now();
      this.pressStartTime = currentTime;
      this.longPressTimer = setTimeout(() => {
        this.executePressDownLogic(event, item);
      }, 500);
    },
    executePressDownLogic(event, item) {
      if (!this.State.pushTalkOpen) return;
      if (!item) {
        const isNumberKey = event.key >= '0' && event.key <= '9';
        const keys = Object.values(this.State.shortCutArray).some(item => item.groupName && item.groupName.toString().includes(event.key));
        if (!isNumberKey || !keys || !this.State.participantPushTalkOpen) return;
      }
      if (!this.State.pressShortCut) {
        if (item) {
          event === null || event === void 0 ? void 0 : event.preventDefault();
          this.State.pressShortCut = item.key;
          this.sendPushTalk(item, true);
        } else {
          Object.keys(this.State.shortCutArray).forEach(key => {
            if (key == Number(event.key) && !event.ctrlKey && !event.altKey && !event.shiftKey) {
              event === null || event === void 0 ? void 0 : event.preventDefault();
              this.State.pressShortCut = Number(event.key);
              this.sendPushTalk(this.State.shortCutArray[key], true);
            }
          });
        }
      }
    },
    listenerKeyUp(event, item) {
      let currentGroup = '';
      if (item) {
        currentGroup = item.key;
      } else {
        Object.keys(this.State.shortCutArray).forEach(key => {
          if (key == Number(event.key) && !event.ctrlKey && !event.altKey && !event.shiftKey) {
            currentGroup = Number(event.key);
          }
        });
      }
      if (this.State.pressShortCut && this.State.pressShortCut != currentGroup) {
        return;
      }
      this.executePressUpLogic(event, item);
    },
    executePressUpLogic(event, item) {
      if (!this.State.pushTalkOpen) return;
      if (!item) {
        const isNumberKey = event.key >= '0' && event.key <= '9';
        const keys = Object.values(this.State.shortCutArray).some(item => item.groupName && item.groupName.toString().includes(event.key));
        if (!isNumberKey || !keys || !this.State.participantPushTalkOpen) return;
      }
      const currentTime = Date.now();
      if (this.longPressTimer) {
        clearTimeout(this.longPressTimer);
        this.longPressTimer = null;
      }
      if (currentTime - (this.pressStartTime || 0) < 500) {
        this.$message.error(this.$t('common.pushTalkFailed'));
        return;
      }
      if (this.State.pressShortCut) {
        if (item) {
          this.State.pressShortCut = 0;
          this.State.pushTalking = false;
          this.sendPushTalk(item, false);
        } else {
          this.State.pressShortCut = 0;
          this.State.pushTalking = false;
          Object.keys(this.State.shortCutArray).forEach(key => {
            if (key == Number(event.key) && !event.ctrlKey && !event.altKey && !event.shiftKey) {
              this.sendPushTalk(this.State.shortCutArray[key], false);
            }
          });
        }
      }
    },
    sendPushTalk(item, val) {
      const voipRtilCodeList = this.State.allRtilCodeArray.filter(rtilCode => {
        return (this.State.rtilCodeKeyTypeVal[rtilCode] === 'T' || this.State.rtilCodeKeyTypeVal[rtilCode] === 'R') && !item.rtilCodeList.includes(rtilCode);
      });
      const params = {
        partyCode: this.userInfo.joinCode,
        startRtilCode: this.userInfo.rtilCode,
        groupName: item.groupName,
        rtilCodeList: item.rtilCodeList,
        voipRtilCodeList,
        talk: val,
        id: item.id
      };
      let url;
      if (this.muteAmAudio) {
        url = val ? '/partyline-backend/pushToTalk/noLogin/enableTalk' : '/partyline-backend/pushToTalk/noLogin/disableTalk';
        params._live = true;
      } else {
        url = '/partyline-backend/pushToTalk/noLogin/talk';
      }
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode === '0x0') {
          this.State.pushTalking = val;
          if (!val) {
            this.State.pressShortCut = 0;
          }
          if (!this.rtc) return;
          // 需要判断当前 mic 是否 mute， 如果 mute 需要临时打开，然后再恢复到原来状态
          if (val) {
            if (!this.State.micStatus[this.userInfo.rtilCode]) {
              var _this$rtc12;
              this.State.micStatus[this.userInfo.rtilCode] = true;
              this.needReMute = true;
              // 判断是否有 audiotrack
              if ((_this$rtc12 = this.rtc) !== null && _this$rtc12 !== void 0 && _this$rtc12._localAudioTrack && this.rtcLoaded) {
                controlDevicePublish(this.rtc, 'publish', [this.rtc._localAudioTrack]);
              } else {
                // 初始化的时候没有本地音频轨道，需要重新获取
                controlAudio(this.rtc, this.devicesInfo, true, result => {});
              }
            }
          } else {
            if (this.needReMute) {
              this.needReMute = false;
              this.State.micStatus[this.userInfo.rtilCode] = false;
              controlDevicePublish(this.rtc, 'unpublish', [this.rtc._localAudioTrack]);
            }
          }
        }
      });
    },
    getAllGroup() {
      let localGroupNumber = 0;
      this.State.shortCutArray = {};
      const params = {
        partyCode: this.userInfo.joinCode
      };
      this.axios.post('/partyline-backend/pushToTalk/noLogin/groupList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach((item, index) => {
            item.rtilCodeList = item.rtilCodeList || [];
            item.rtilCodeList = item.rtilCodeList.filter(rtilCode => {
              return rtilCode !== this.userInfo.rtilCode && rtilCode != this.State.outputCode;
            });
            this.$set(this.State.currentPushTalkInfo, item.id, item);
            if (item.partyCode == this.userInfo.joinCode) {
              localGroupNumber++;
              this.$set(this.State.shortCutArray, localGroupNumber < 9 ? localGroupNumber : 0, item);
            }
          });
          console.log(1111111111111, 'saveValue');
          this.State.groupList = result.filter(item => {
            return item.partyCode == this.userInfo.joinCode && item.startRtilCode == this.userInfo.rtilCode;
          });
        }
      });
    },
    canSaveToGlobal(type, id) {
      let flag = true;
      if (type == 'R' || type == 'T' || this.sttRtilCode == id || this.outputRtilCode && this.outputRtilCode == id || this.State.allRtilCodes.includes(id)) {
        flag = false;
      }
      return flag;
    },
    copySummary() {
      if (navigator.clipboard) {
        const text = this.State.summaryInfo.contentText;
        navigator.clipboard.writeText(text).then(() => {
          this.$message({
            message: this.$t('aiSpeech.copySuccess'),
            type: 'success'
          });
        }).catch(() => {
          this.$message({
            message: this.$t('aiSpeech.copyFail'),
            type: 'error'
          });
        });
      } else {
        this.$message({
          message: this.$t('aiSpeech.notSupportCopy'),
          type: 'error'
        });
      }
    },
    downloadSummary() {
      const text = this.State.summaryInfo.contentText;
      const blob = new Blob([text], {
        type: 'text/plain'
      });
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', 'summary.txt'); // 指定下载文件的名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    },
    getAllPrivate() {
      const params = {
        annotation: this.partyCode,
        key: 'privateChat',
        value: true
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/getPartyCodeKey', params).then(async res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            const mark = Number(item.mark);
            const subKey = Number(item.subKey);
            const remark = Number(item.remark);
            if (remark && subKey == this.rtilCode) {
              this.sendPrivateToMeRtilcodes.push(mark);
            }
            if (!this.State.startPrivateInfo[mark]) {
              this.$set(this.State.startPrivateInfo, mark, [subKey]);
            } else {
              if (!this.State.startPrivateInfo[mark].includes(subKey)) this.State.startPrivateInfo[mark].push(subKey);
            }
            if (remark && remark == this.userInfo.rtilCode && !this.State.localSendPrivateArray.includes(subKey)) {
              this.State.localSendPrivateArray.push(subKey);
            }
          });
        }
      });
    },
    async controlAudioMatrix(val) {
      const _this = this;
      if (val) {
        await this.getMyselfMuteInfo({
          realPartyCode: this.partyCode,
          rtilCode: this.rtilCode
        });
        this.getAllAudioMatrixMute();
      } else {
        this.myselfMuteInfo = {};
        this.State.matrixInfoMuteMap = {};
        this.State.matrixInfoUnTalkMap = {};
        Object.keys(_this.channels).forEach(rtilCode => {
          if (_this.channels[rtilCode] && _this.channels[rtilCode].muteByAudioMatrix) {
            var _this$rtc13;
            (_this$rtc13 = this.rtc) === null || _this$rtc13 === void 0 ? void 0 : _this$rtc13.subscribe(rtilCode, 'audio');
          }
        });
      }
    },
    closeSettingDialog() {
      this.settingPopupInfo.show = false;
      Bus.$emit('closePartiAudioMatrix');
    },
    // 给host发送自己与会者的设备信息
    sendMediaInfoToHost(id) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'sendMediaInfoToHost',
          rtilCode: id,
          deviceInfo: this.devicesInfo,
          control: this.State.partyJoinInfo.behavior.enableControlMedia
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    getAllAudioMatrixMute() {
      const _this = this;
      this.axios.get(`/partyline-backend/audioMatrix/noLogin/getAll?partyCode=${this.State.partyCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            this.$set(this.State.matrixInfoMuteMap, item.rtilCode, item.muteRtilCodes);
            this.$set(this.State.matrixInfoUnTalkMap, item.rtilCode, item.unTalkRtilCodes);
            if (_this.State.matrixInfoUnTalkMap[item.rtilCode] && _this.State.matrixInfoUnTalkMap[item.rtilCode].includes(_this.rtilCode)) {
              var _this$myselfMuteInfo$7;
              (_this$myselfMuteInfo$7 = _this.myselfMuteInfo.muteRtilCodes) === null || _this$myselfMuteInfo$7 === void 0 ? void 0 : _this$myselfMuteInfo$7.push(item.rtilCode);
            }
          });
        }
      });
    },
    // co-host
    controlCohostInvite(val) {
      const params = {
        collaborateLogId: this.coHostInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptHostSuccess'));
            routerJump('party', {
              id: this.State.partyCode
            });
          } else {
            this.$message.success(this.$t('personalInfo.acceptHostCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    controlInvite(val) {
      const params = {
        collaborateLogId: this.collaborateInfo.info.collaborateLogId,
        optionType: val ? 1 : 2
      };
      this.axios.post(`/partyline-backend/collaborate/noLogin/updateStatus?collaborateLogId=${params.collaborateLogId}&optionType=${params.optionType}`, params, {
        errorTip: false
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          if (params.optionType == 1) {
            this.$message.success(this.$t('personalInfo.acceptSuccess'));
          } else {
            this.$message.success(this.$t('personalInfo.acceptCancel'));
          }
        } else if (res.data.errorCode == '82203101') {
          this.$message.warning(this.$t('common.invitedExpire'));
        }
      });
    },
    controlModify(agreeControl) {
      var _this$controlMediaInf;
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'responseControlMedia',
          rtilCode: this.rtilCode,
          agreeControl,
          type: this.controlMediaInfo.info.type,
          deviceId: this.controlMediaInfo.info.type === 'video' ? this.devicesInfo.cameraId : this.devicesInfo.microphoneId
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {
        agreeControl ? this.$message.success(this.$t('common.setMicCameraSuccess')) : this.$message.success(this.$t('common.denySuccess'));
        this.saveOperation(agreeControl);
      });
      if (agreeControl && (_this$controlMediaInf = this.controlMediaInfo.info) !== null && _this$controlMediaInf !== void 0 && _this$controlMediaInf.deviceId) {
        this.rtc.setDevice(this.controlMediaInfo.info.deviceId, this.controlMediaInfo.info.type, result => {
          if (result) {
            if (this.controlMediaInfo.info.type === 'video') {
              this.devicesInfo.cameraId = this.controlMediaInfo.info.deviceId;
              // this.rtc?._localVideoTrack && this.rtc._localVideoTrack.setEnable(false)
            } else {
              this.devicesInfo.microphoneId = this.controlMediaInfo.info.deviceId;
            }
            this.sendResultToHost(true);
          } else {
            this.sendResultToHost(false);
          }
        });
      }
    },
    saveOperation(value) {
      if (!this.rtilCode || !this.State.partyJoinInfo.realPartyCode) return;
      const params = [{
        mark: this.rtilCode + '',
        annotation: this.State.partyJoinInfo.realPartyCode,
        key: 'enableControlMedia',
        value,
        notify: true
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0' && value) {
          this.State.partyJoinInfo.behavior.enableControlMedia = 'true';
        }
      });
    },
    sendResultToHost(val) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'operateMediaResult',
          rtilCode: this.rtilCode,
          origin: 'host',
          val
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    listenerTalkBack(event) {
      if (event.ctrlKey && event.keyCode === 76) {
        if (this.$refs.pipBox && this.talkbackStatus) {
          this.setTalkback();
        }
        window.event.preventDefault();
      }
    },
    getLayoutRowAndColumn() {
      let pipNum = 0;
      // output 是自己的时候不需要加 1
      if (this.outputRtilCode == this.userInfo.rtilCode) {
        pipNum = this.rtilCodeList.length;
      } else {
        pipNum = this.rtilCodeList.length + 1; // +1为me
      }

      if (this.outputRtilCode || this.largeScreenRtilCode) {
        let row = 2;
        let column = 3;
        const num = pipNum + 4;
        if (num <= 6) {
          column = 3;
        } else if (num <= 10) {
          column = 4;
        } else if (num <= 20) {
          column = 5;
        } else if (num <= 30) {
          column = 6;
        } else if (num <= 42) {
          column = 7;
        } else if (num <= 48) {
          column = 8;
        } else {
          column = 9;
        }
        row = num % column ? parseInt(num / column) + 1 : parseInt(num / column);
        this.videoCanvasColumn = column;
        return {
          row,
          column,
          pipNum
        };
      } else {
        let column = 2;
        let row = 1;
        if (pipNum == 1) {
          column = 1;
        } else if (pipNum <= 4) {
          column = 2;
        } else if (pipNum <= 9) {
          column = 3;
        } else if (pipNum <= 16) {
          column = 4;
        } else if (pipNum <= 25) {
          column = 5;
        } else if (pipNum <= 31) {
          column = 6;
        } else if (pipNum <= 42) {
          column = 7;
        } else {
          column = 8;
        }
        row = pipNum % column ? parseInt(pipNum / column) + 1 : parseInt(pipNum / column);
        this.videoCanvasColumn = column;
        return {
          row,
          column,
          pipNum
        };
      }
    },
    changeLayout() {
      // 获取整个视频画布的宽高
      const videoCanvasWidth = this.$refs.videoCanvas && this.$refs.videoCanvas.clientWidth;
      const videoCanvasHeight = this.$refs.videoCanvas && this.$refs.videoCanvas.clientHeight - 5 - 5; // (40是距离头部的距离，5是距离头部按钮的距离)
      const {
        row,
        column
      } = this.getLayoutRowAndColumn();
      const percent = 16 * column / (9 * row);
      // 根据屏幕的自适应获取可适应的16:9的宽度
      if (videoCanvasWidth / percent > videoCanvasHeight) {
        // 画布的高不够，需要减少画布的宽，计算出在此高度下的最大宽
        this.videoCanvasWidth = `${videoCanvasHeight * percent}px`;
      } else {
        this.videoCanvasWidth = null;
      }
      console.info('计算 layout 的布局', `(videoCanvasWidth: ${videoCanvasWidth})`, `(videoCanvasHeight:${videoCanvasHeight})`, videoCanvasWidth / percent > videoCanvasHeight, `row:${row}`, `column:${column}`, this.videoCanvasWidth);
    },
    handleRtilCodeList() {
      let codeList = JSON.parse(JSON.stringify(this.allRtilList));
      const shareList = JSON.parse(JSON.stringify(this.shareList));
      // Me始终放在第一个位置
      codeList = codeList.filter(v => v != this.userInfo.rtilCode);
      // 如果有 share 需要把 share 视频分别放在各自发起者的右边
      if (this.shareRtilCode && codeList.find(rtilCode => rtilCode == this.shareRtilCode)) {
        // 如果当前 host 在分享先把 自己分想的 rtilCode 去掉并添加到第一位去
        codeList = codeList.filter(rtilCode => rtilCode != this.shareRtilCode);
        codeList.unshift(this.shareRtilCode);
        // 删除 host 的记录
        if (shareList[this.shareRtilCode]) this.$delete(shareList, this.shareRtilCode);
      }
      // 先去掉所有 share 的 RtilCode
      codeList = codeList.filter(rtilCode => !shareList[rtilCode]);

      // 根据最新需求屏幕分享要在与会者视频右边
      for (let i = 0; i < codeList.length; i++) {
        if (this.rtilCodeByShare[codeList[i]] && this.rtilCodeByShare[codeList[i]] != this.outputRtilCode && this.rtilCodeByShare[codeList[i]] != this.largeScreenRtilCode) {
          codeList.splice(i + 1, 0, this.rtilCodeByShare[codeList[i]]);
        }
      }
      // 把放大的放回 rtilCodeList
      if (this.largeScreenRtilCode && this.outputRtilCode && this.outputRtilCode != this.largeScreenRtilCode) {
        if (!codeList.includes(this.outputRtilCode)) codeList.push(this.outputRtilCode);
      }
      // 处理 mainwindow 和左右布局
      const removeRtilCode = this.largeScreenRtilCode || this.outputRtilCode;
      codeList = codeList.filter(v => v != removeRtilCode);
      if (this.sttRtilCode) {
        if (codeList.includes(this.sttRtilCode)) {
          this.State.showAISpeech = true;
        }
        this.rtilCodeList = codeList.filter(rtilCode => {
          return rtilCode != this.sttRtilCode;
        });
        this.allPartyMembers = this.allPartyMembers.filter(rtilCode => {
          return rtilCode != this.sttRtilCode;
        });
        this.State.allRtilCodeArray = this.State.allRtilCodeArray.filter(rtilCode => {
          return rtilCode != this.sttRtilCode;
        });
      } else {
        this.rtilCodeList = codeList;
      }
    },
    dealCamera(val) {
      if (!this.rtcLoaded) return;
      controlCamera(this.rtc, this.devicesInfo, val);
      controlDeviceBehavior({
        senderRtilCode: this.userInfo.rtilCode,
        type: 'camera',
        value: val,
        partyCode: this.userInfo.realPartyCode,
        toRtilCode: this.userInfo.rtilCode,
        origin: 'commonPartyHost',
        notChangeStatus: true
      });
    },
    async dealMic(val) {
      var _this$rtc14;
      if (!this.rtcLoaded) return;
      if (this.osLevelmicMuted && !val) {
        this.showMicMutedInfo.show = true;
        return;
      }
      let operationResult = 'success';
      let time = 0;
      if ((_this$rtc14 = this.rtc) !== null && _this$rtc14 !== void 0 && _this$rtc14._localAudioTrack) {
        const type = val ? 'publish' : 'unpublish';
        time = new Date().getTime();
        console.log('time', time);
        operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
      } else {
        // 初始化的时候没有本地音频轨道，需要重新获取
        controlAudio(this.rtc, this.devicesInfo, val, result => {
          if (result == 'failed') operationResult = 'failed';
        });
      }
      if (operationResult === 'success') {
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'mic',
          value: val,
          partyCode: this.userInfo.realPartyCode,
          toRtilCode: this.userInfo.rtilCode,
          origin: 'commonPartyHost',
          notChangeStatus: true
        });
        console.log('time', new Date().getTime() - time);
        // 恢复听自己声音功能
        if (val && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
          this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
            type: 'audio'
          });
        }
      }
    },
    dealShowChat(val) {
      this.State.showChatMessage = val;
      if (val) this.showAISpeech = false;
      this.$nextTick(() => {
        this.changeLayout();
      });
    },
    async dealFootEvent(info) {
      const {
        type,
        val,
        shareType
      } = info;
      switch (type) {
        case 'muteVideo':
          this.dealCamera(val);
          break;
        case 'muteAudio':
          this.dealMic(val);
          break;
        case 'changeDevice':
          this.changeDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
        case 'shareScreen':
          this.shareScreen(shareType);
          break;
        case 'showChat':
          this.dealShowChat(val);
          break;
        case 'showAISpeechPop':
          this.aiPolicyInfo.show = true;
          break;
        case 'showAISpeech':
          this.showAISpeech = val;
          if (val) {
            this.State.showChatMessage = false;
          }
          this.$nextTick(() => {
            this.changeLayout();
          });
          break;
        case 'leave':
          Bus.$emit('showDialog', {
            show: true,
            realPartyCode: this.partyCode,
            rtilCode: this.userInfo.rtilCode
          });
          break;
        case 'hearSelfFeature':
          if (val) {
            this.hearSelf = true;
            if (this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute && this.rtc) {
              this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
          } else {
            this.hearSelf = false;
            if (this.rtc && this.rtc._localAudioTrack) {
              this.rtc._localAudioTrack.stop(this.rtc._localAudioTrack);
            }
          }
          this.saveHearSelfBehavior(val);
          break;
      }
    },
    saveHearSelfBehavior(value) {
      if (!this.userInfo.rtilCode || !this.userInfo.realPartyCode) return;
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.userInfo.realPartyCode,
        key: 'hearSelf',
        value
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {
        if (res.data.errorCode === '0x0') {
          if (!value) {
            this.hearSelf = false;
            this.$refs.footDiv.changeHearSelfValue(false);
          }
        }
      });
    },
    async getOnlineMember() {
      await this.axios.get('/partyline-backend/commonParty/noLogin/getViewRtilCodes', {
        params: {
          partyCode: this.partyCode
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          const list = res.data.result.viewPosition.total;
          this.allRtilList = list.map(v => {
            if (!this.channels[v]) {
              this.$set(this.channels, v, {
                id: v
              });
            }
            this.getNickName(v);
            return v;
          });
          this.handleRtilCodeList();
        }
      });
    },
    getRtcStats({
      videoQuality,
      videoQualities
    }) {
      if (videoQuality == 'high') {
        var _this$rtc15;
        (_this$rtc15 = this.rtc) === null || _this$rtc15 === void 0 ? void 0 : _this$rtc15.setEncoderConfiguration(videoQualities[0]);
      } else {
        var _this$rtc16;
        (_this$rtc16 = this.rtc) === null || _this$rtc16 === void 0 ? void 0 : _this$rtc16.setEncoderConfiguration(this.resolutionRange['360p']);
      }
    },
    async getBehaviorsByMemberId() {
      if (!this.partyCode.trim()) return;
      const params = {
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        annotation: this.partyCode.trim(),
        keys: ['nickName']
      };
      handleLocalStorage('set', 'memberId', params.memberId);
      const res = await this.axios.post('/partyline-backend/behavior/noLogin/getListByMemberId', params);
      if (!res) return;
      const result = res.data.result;
      const {
        rtilCode,
        behaviors
      } = result;
      if (res.data.errorCode == '0x0' && rtilCode) {
        this.behaviorInfo[rtilCode] = behaviors[rtilCode].nickName;
        this.$set(this.State.globalNameInfo, rtilCode, behaviors[rtilCode].nickName);
      }
      return rtilCode;
    },
    async setNameOrJoin() {
      if (this.rtc) this.rtc.leave();
      this.rtc = new AgoraClient(this.callBack);
      // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
      const devices = await this.newRtc.getDevice();
      this.cameraId = devices.cameraId;
      this.microphoneId = devices.microphoneId;
      this.devicesInfo = devices;
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
      const rtilCode = await this.getBehaviorsByMemberId();
      if (rtilCode && this.behaviorInfo[rtilCode]) {
        this.joinPartyLine(); // 有rtilCode代表设置过nickName
      } else {
        // 直接通过join接口去添加nickName（新用户）
        routerJump('preview', {
          id: this.partyCode
        });
      }
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        const rtilCodes = [this.userInfo.rtilCode];
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket && socket.client.readyState === 1 && rtilCodes.length && partyCode == this.$route.query.id) {
          socket.send(params);
        }
      }, 1000);
    },
    showTalkbackTitle(haveSetTalkback) {
      let _str = '';
      haveSetTalkback ? _str = this.$t('commonSetting.offLazyAudioTips') : _str = this.$t('commonSetting.turnOnLazy');
      return _str;
    },
    setTalkback() {
      const params = {
        partyCode: this.userInfo.joinCode,
        module: this.talkBackInfo[this.userInfo.rtilCode] ? 'cancelParticipantTalkBack' : 'setParticipantTalkBack',
        msg: {
          rtilCode: this.userInfo.rtilCode,
          initiator: this.userInfo.rtilCode
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=98684', params);
    },
    changeDevice(obj) {
      if (!this.rtc) return;
      if (obj.type == 'speaker') {
        handleLocalStorage('set', 'speakerId', obj.deviceId);
        // mainWindow切换
        if (this.outputRtilCode) {
          this.$refs.mainwindowBox && this.$refs.mainwindowBox.setSpeakerAttendUser();
        }
        // 与会者切换
        this.$nextTick(() => {
          this.rtilCodeList.forEach(rtilCode => {
            if (this.$refs[`remoteSource${rtilCode}`][0] && rtilCode != this.outputRtilCode) {
              this.$refs[`remoteSource${rtilCode}`][0].setSpeakerAttendUser();
            }
          });
        });
      }
      console.log('log:', 'changeDevice', obj.type, obj.deviceId);
      if (!obj.deviceId) return;
      this.rtc.setDevice(obj.deviceId, obj.type, result => {
        if (obj.type == 'audio' && result === 'success') {
          this.$refs.pipBox.reUseAudioWorklet();
          this.detecteMicMuted();
        }
        if (obj.type === 'video' && result === 'success' && !this.State.cameraStatus[this.rtilCode]) {
          var _this$rtc17;
          ((_this$rtc17 = this.rtc) === null || _this$rtc17 === void 0 ? void 0 : _this$rtc17._localVideoTrack) && this.rtc._localVideoTrack.setEnabled(false);
        }
      });
      this.sendToHostChange(obj.deviceId, obj.type);
    },
    sendToHostChange(deviceId, type) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'changeMediaInfo',
          rtilCode: this.rtilCode,
          type,
          deviceId
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    setCameraStatus() {
      controlCamera(this.rtc, this.devicesInfo, true);
      controlDeviceBehavior({
        senderRtilCode: this.userInfo.rtilCode,
        type: 'camera',
        value: true,
        partyCode: this.userInfo.realPartyCode,
        toRtilCode: this.userInfo.rtilCode,
        origin: 'commonPartyHost'
      });
    },
    sendToHost(type, value) {
      const params = {
        module: 'responseControlBehavior',
        partyCode: this.partyCode,
        origin: 'commonPartyParticipate',
        msg: {
          key: type,
          senderRtilCode: this.userInfo.rtilCode,
          rtilCode: this.hostControlPipRtilCode[type],
          responseCode: value
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=30228', params);
    },
    chatCallback({
      type,
      rtilCode,
      data
    }) {
      if (type == 'nickName') {
        this.getNickName(rtilCode);
      }
      if (type == 'unreadInfo') {
        this.showUnread = false;
        Object.keys(data).forEach(keys => {
          if (data[keys].unRead) {
            this.showUnread = true;
          }
        });
      }
    },
    async operateCallback(obj) {
      const {
        type,
        pipInfo,
        val,
        id
      } = obj;
      if (type == 'muteVideo') {
        controlCamera(this.rtc, this.devicesInfo, val);
        controlDeviceBehavior({
          senderRtilCode: this.userInfo.rtilCode,
          type: 'camera',
          value: val,
          partyCode: this.userInfo.realPartyCode,
          toRtilCode: this.userInfo.rtilCode,
          origin: 'commonPartyHost'
        });
      } else if (type === 'muteAudio') {
        var _this$rtc18;
        let operationResult = 'success';
        if ((_this$rtc18 = this.rtc) !== null && _this$rtc18 !== void 0 && _this$rtc18._localAudioTrack && this.rtcLoaded) {
          const type = val ? 'publish' : 'unpublish';
          operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
        } else {
          // 初始化的时候没有本地音频轨道，需要重新获取
          controlAudio(this.rtc, this.devicesInfo, val, result => {
            if (result == 'failed') operationResult = 'failed';
          });
        }
        if (operationResult === 'success') {
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: this.userInfo.realPartyCode,
            toRtilCode: this.userInfo.rtilCode,
            origin: 'commonPartyHost'
          });
          // 恢复听自己声音功能
          if (val && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
            this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
              type: 'audio'
            });
          }
        }
      } else if (type == 'startPrivateConversation' || type == 'cancelPrivateConversation') {
        this.praivateParams = obj;
        this.privateConversationFn(obj, 'send');
      } else if (type == 'switchFullScreen') {
        this.largeScreenRtilCode = val ? pipInfo.id : '';
        if (pipInfo.id == this.outputRtilCode) {
          if (!val) {
            if (pipInfo.id == this.userInfo.rtilCode && pipInfo.id == this.outputRtilCode) {
              this.$nextTick(() => {
                this.channels[pipInfo.id] = {
                  ...this.channels[pipInfo.id],
                  ...pipInfo
                };
              });
            }
          }
        } else {
          if (pipInfo.id == this.largeScreenRtilCode && this.rtc) {
            if (this.State.audioType == 1) {
              this.dealLocalShareScreen(pipInfo.id, 'needControlPlay', '', false);
              this.channels[pipInfo.id].hasUnsubscribe = true;
            }
          }
          if (val) {
            this.shareInitiator = pipInfo.shareInitiator;
          } else {
            this.shareInitiator = '';
          }
          this.$nextTick(() => {
            if (pipInfo.id == this.userInfo.rtilCode) {
              var _this$rtc19, _this$rtc19$_localVid;
              (_this$rtc19 = this.rtc) === null || _this$rtc19 === void 0 ? void 0 : (_this$rtc19$_localVid = _this$rtc19._localVideoTrack) === null || _this$rtc19$_localVid === void 0 ? void 0 : _this$rtc19$_localVid.play('local_stream');
            }
          });
        }
        this.$nextTick(() => {
          Bus.$emit('changeMainwindowFullScreen', {
            value: val,
            id: pipInfo.id
          });
          if (pipInfo.id == this.largeScreenRtilCode && this.rtc) {
            this.dealLocalShareScreen(pipInfo.id, 'needControlPlay', 'unExecuteCallback', true);
            this.channels[pipInfo.id].hasUnsubscribe = false;
          }
        });
        this.handleRtilCodeList();
      } else if (type === 'fullScreen') {
        this.isFullScreen = val;
        this.State.fullScreen = val;
        this.$set(this.fullScreenInfo, id, val);
        if (val && getFullscreenEnabled()) {
          document.documentElement.requestFullscreen && document.documentElement.requestFullscreen();
        }
      } else if (type === 'audioContext') {
        this.localVolume = val;
      }
    },
    async privateConversationFn(obj, send) {
      const {
        type,
        rtilCode,
        channel,
        receive,
        ack
      } = obj;
      if (!channel) return;
      // 开启talkback，无法私聊
      if (this.talkbackStatus && (this.talkBackInfo[rtilCode] || this.talkBackInfo[this.userInfo.rtilCode])) {
        this.$message.warning(this.$t('commonFunction.participantTips'));
        return;
      }
      if (this.State.pushTalkOpen) {
        this.$message.warning(this.$t('commonFunction.pushTalkTips'));
        return;
      }
      const params = {
        partyCode: channel,
        rtilCode: this.userInfo.rtilCode,
        startRtilCode: receive ? '' : !this.sendPrivateToMeRtilcodes.includes(rtilCode) ? this.userInfo.rtilCode : '',
        receiveRtilCode: rtilCode,
        msg: {
          ack: send ? 0 : ack
        },
        value: type == 'startPrivateConversation'
      };
      this.axios.post('/partyline-backend/intercom/noLogin/i', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const nickName = this.behaviorInfo[rtilCode];
          if (params.startRtilCode && type == 'startPrivateConversation' && !receive) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.sendTwoWayPrivate', {
                nickName
              })
            });
          } else if (!params.startRtilCode && type == 'startPrivateConversation' && !receive) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.sendOneWayPrivate', {
                nickName
              })
            });
          } else if (!params.startRtilCode && type == 'cancelPrivateConversation' && !receive) {
            this.$message({
              type: 'success',
              message: this.$t('commonPartyHost.endOneWayPrivate', {
                nickName
              })
            });
          }
        }
      });
    },
    userJoin(payload) {
      const {
        id
      } = payload;
      !this.State.allRtilCodeArray.includes(id) && this.State.allRtilCodeArray.push(id);
      this.$set(this.fullScreenInfo, id, false);
      // 设置默认为device的status
      this.State.haveUnReadMessage = true;
      this.$set(this.State.cameraStatus, id, false);
      this.$set(this.State.micStatus, id, false);
      this.getVideoType(payload);
    },
    subscribeTrack(payload) {
      try {
        var _this$myselfMuteInfo$8;
        const {
          id,
          videoTrack,
          audioTrack
        } = payload;
        if (this.State.localShareInfo[id]) return;
        const obj = Object.assign({}, this.channels[id]);
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && (_this$myselfMuteInfo$8 = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$8 !== void 0 && _this$myselfMuteInfo$8.includes(id)) {
          var _this$rtc20;
          // 首先判断是否处于私聊状态,在私聊的状态可以不受 host audio matrix 的控制
          obj.muteByAudioMatrix = true;
          (_this$rtc20 = this.rtc) === null || _this$rtc20 === void 0 ? void 0 : _this$rtc20.unsubscribe(id, 'audio');
        }
        this.$set(this.channels, id, obj);
        // if (videoTrack) {
        //   videoTrack.on('sei-received', array => {
        //     const info = JSON.parse(this.Uint8ArrayToString(array))
        //     console.log('log sei', id, info.timestamp)
        //   })
        // }
      } catch (error) {}
    },
    // 处理初始化及其他 audio-only 时的视频订阅问题
    dealSubscribeVideo(payload) {
      const _this = this;
      const {
        id
      } = payload;
      // 因为还没有后面赋值所以先添加上
      if (!this.channels[id]) {
        this.$set(this.channels, id, {
          id: id
        });
      }
      const pinnCode = this.outputRtilCode || this.largeScreenRtilCode;
      if (pinnCode && pinnCode == id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2) {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
          } else {
            this.channels[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              this.channels[id].hasUnsubscribe = false;
              this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
            } else {
              this.channels[id].hasUnsubscribe = true;
            }
          } else {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
          }
        }
      } else if (this.shareRtilCode && this.shareRtilCode == id) {
        if (this.State.audioType || this.State.audioType == 2) {
          if (this.State.checkShareScreen) {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
          } else {
            this.channels[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkShareScreen) {
              this.channels[id].hasUnsubscribe = false;
              this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
            } else {
              this.channels[id].hasUnsubscribe = true;
            }
          } else {
            this.channels[id].hasUnsubscribe = false;
            this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
          }
        }
      } else {
        if (this.State.audioType == 1) {
          _this.channels[id].hasUnsubscribe = true;
        } else {
          this.dealLocalShareScreen(id, 'needControlPlay', 'unExecuteCallback', true);
          this.channels[id].hasUnsubscribe = false;
        }
      }
    },
    muteAudioOrVideo(action, payload) {
      const {
        id,
        mediaType
      } = payload;
      const val = action === 'user-published';
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, val) : this.$set(this.State.micStatus, id, val);
    },
    async getNickName(id, key, sourceInfo) {
      if (!this.partyCode) return;
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode,
        keys: ['avatar', 'nickName', 'voipRid', 'voipSourceId', 'flipVideo', 'voiceCommand'],
        marks: [id]
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          // 1、分享画面在分享者之后加进来 直接去分享者nickname
          // 2、分享在分享之之前进来（刷新页面） 找到分享者并赋值
          const result = res.data.result[id];
          if (key) {
            this.$set(this.behaviorInfo, key, result.nickName);
            this.$set(this.State.globalNameInfo, key, result.nickName);
          } else {
            if (!this.behaviorInfo[id]) {
              this.$set(this.degreeHost, id, result.flipVideo);
              this.$set(this.behaviorInfo, id, result.nickName);
              this.$set(this.State.globalNameInfo, id, result.nickName);
            }
          }
          // pip头像相关
          this.$set(this.avatarInfo, id, result.avatar);
          this.isNotLoginArray = Object.keys(this.avatarInfo).filter(key => this.avatarInfo[key] === null);
          if (result.voiceCommand === 'true' && !this.State.voiceCommandList.includes(id)) {
            this.State.voiceCommandList.push(id);
          }
          const _this = this;
          if (id == _this.userInfo.rtilCode && result.voipRid) {
            this.selectRid = result.voipRid;
            this.sourceId = result.voipSourceId;
            this.needStartVoip = true;
          }
        }
      });
    },
    setNickName(data) {
      this.joinPartyLine(data);
    },
    joinPartyLine(behaviors) {
      const haveHistoryMem = handleLocalStorage('get', 'memberId');
      const params = {
        memberId: haveHistoryMem || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 0,
        host: false,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'enableControlMedia', 'flipVideo', 'summaryLanguage'],
        invitePassCode: this.passWord
      };
      if (behaviors) params.behaviors = behaviors;
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        routeName: this.$route.query.from,
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          var _result$stt, _this$rtc21;
          const result = res.data.result;
          const {
            status,
            behavior,
            createTime
          } = result;
          this.rtilCode = result.rtilCode;
          this.$set(this.degreeHost, result.rtilCode, behavior.flipVideo);
          this.userInfo = result;
          this.pipVolume = status.pipVolume;
          this.getAllPrivate();
          addTabTitle({
            userInfo: result
          });
          this.sttRtilCode = (_result$stt = result.stt) === null || _result$stt === void 0 ? void 0 : _result$stt.outputRtilCode;
          if (this.sttRtilCode && result.stt.running) {
            this.getHistoryData(result);
          }
          // 判断登入账号是否为内部账号
          if ((_this$rtc21 = this.rtc) !== null && _this$rtc21 !== void 0 && _this$rtc21._AgoraRTC && JSON.stringify(this.State.checkEnv) != '{}' && this.State.checkEnv.userEmail.includes('tvunetworks') && process.env.NODE_ENV === 'production') {
            this.rtc._AgoraRTC.setLogLevel(0);
            this.rtc._AgoraRTC.enableLogUpload();
          }
          this.State.aiBotEnable = status.voiceCommand;
          // 为了 Audio Matrix 添加获取当前是否有静音人的数据
          await this.getMyselfMuteInfo(result);
          this.allPartyMembers.unshift(result.rtilCode);
          status.disableTalkInvokeAm === 1 ? this.muteAmAudio = true : this.muteAmAudio = false;
          status.lockName === 0 ? this.lockName = true : this.lockName = false;
          status.volumeEffect === 0 ? this.audioLevel = true : this.audioLevel = false;
          this.talkbackStatus = (status === null || status === void 0 ? void 0 : status.talkBack) === 'true';
          this.State.talkbackStatus = (status === null || status === void 0 ? void 0 : status.talkBack) === 'true';
          this.State.partyJoinInfo = result;
          this.State.partyCode = result.realPartyCode;
          this.State.productionId = status.voiceCommandProduction;
          this.getAllAudioMatrixMute();
          this.State.audioType = behavior.audioOnlyType ? Number(behavior.audioOnlyType) : 2;
          this.State.checkMainWindow = behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = behavior.checkAudioShare !== 'false';
          this.State.audioMatrixEnable = status.audioMatrix;
          this.State.participantRole = result.participantRole;
          Bus.$emit('changeAudioTypeVal');
          Bus.$emit('changeAudioMatrix', {
            host: status.audioMatrix,
            participant: status.participantAudioMatrix
          });
          status.participantAudioMatrix ? this.State.partiAudioMatrixEnable = true : this.State.partiAudioMatrixEnable = false;
          this.$set(this.talkBackInfo, result.rtilCode, behavior.talkBack === 'true');
          status.talkBackList.forEach(v => {
            this.$set(this.controlMuteInfo, v.rtilCode, true);
            this.$set(this.talkBackInfo, v.rtilCode, true);
          });
          if (!this.State.allRtilCodes.includes(result.rtilCode)) {
            this.State.allRtilCodes.push(result.rtilCode);
          }
          if (!this.State.allRtilCodeArray.includes(result.rtilCode)) {
            this.State.allRtilCodeArray.push(result.rtilCode);
          }
          this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != this.sttRtilCode);
          this.State.allRtilCodeArray = this.State.allRtilCodeArray.filter(v => v != this.sttRtilCode);
          this.outputRtilCode = status.output;
          this.largeScreenRtilCode = status.output;
          this.intercom = status.intercom;
          this.State.intercom = status.intercom;
          if (this.outputRtilCode) {
            this.$nextTick(() => {
              Bus.$emit('changeMainwindowFullScreen', {
                value: true,
                id: this.outputRtilCode
              });
            });
          }
          if (status.hearThemSelf) {
            this.iconList.forEach(item => {
              if (item === 'speaker') {
                this.iconList.push('hearMyself');
              }
            });
          }
          if (status.pushToTalk) {
            if (status.pipPushToTalk) this.State.participantPushTalkOpen = true;
            this.getAllGroup();
          }
          if (status.pushToTalk) {
            this.State.pushTalkOpen = true;
          }
          this.startHearSelf = !!status.hearThemSelf;
          this.hearSelf = behavior.hearSelf === 'true';
          this.translateInto = behavior.summaryLanguage ? behavior.summaryLanguage : '';
          this.$refs.footDiv.changeHearSelfValue(this.hearSelf);
          this.getOnlineMember();
          this.joinParam = {
            ...result,
            partyCode: this.partyCode,
            memberId: params.memberId
          };
          const nickName = behavior.nickName;
          behavior.speaker = behavior.speaker !== 'false';
          behavior.camera = behavior.camera !== 'false';
          behavior.mic = behavior.mic !== 'false';
          this.$set(this.behaviorInfo, this.userInfo.rtilCode, nickName);
          this.joinAgoraClient(result, behavior, this.joinParam);
          this.$set(this.State.globalNameInfo, this.userInfo.rtilCode, nickName);
          Bus.$emit('changePartyAddress', {
            currentId: this.partyCode,
            title: result.title,
            createTime
          });
          // 用于向别的组件传递初始化数据
          Bus.$emit('updateInitStatus', {
            hasCopy: result.status.hasCopy !== 0,
            loginButton: result.status.loginButton !== 0
          });
          // 是否设置私聊
          if (status.privateConversation) {
            Bus.$emit('startPrivateConversation', JSON.parse(status.privateConversation));
          }
        } else if (res.data.errorCode === '82200603') {
          routerJump('remove', {
            type: 'fullParty',
            number: res.data.errorInfo
          });
        } else if (res.data.errorCode === '80520103') {
          var _this$Config$urlInfo;
          const userServerUrl = (_this$Config$urlInfo = this.Config.urlInfo) === null || _this$Config$urlInfo === void 0 ? void 0 : _this$Config$urlInfo.userservice;
          const publicPath = this.State.publicPath || 'partyline';
          window.location.href = `${userServerUrl}/?url=${location.protocol}//${location.host}/${publicPath}?join_id=${this.partyCode}&serviceName=Partyline`;
        } else if (res.data.errorCode === '80520104') {
          routerJump('remove', {
            type: 'noCommonpartyPermission'
          });
        } else if (res.data.errorCode === '80520107') {
          routerJump('remove', {
            type: 'needPassCode',
            partyCode: this.partyCode
          });
        } else if (res.data.errorCode === '80520113') {
          this.$message.error(this.$t('partyInfo.partyDisabled'));
        }
      }).catch(err => {
        if (err.status === 400) {
          this.$message.error('Not exit party');
          routerJump('joinPage');
        }
      });
    },
    controlMainwindow(rtilCode) {
      if (!this.partyCode) return;
      const params = {
        partyCode: this.partyCode,
        rtilCode: rtilCode
      };
      this.axios.post(`/partyline-backend/partyAction/setOutput?partyCode=${this.partyCode}`, params).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    async getMyselfMuteInfo(info) {
      await this.axios.get(`/partyline-backend/audioMatrix/noLogin/get?partyCode=${info.realPartyCode}&rtilCode=${info.rtilCode}`).then(res => {
        const {
          errorCode
        } = res.data;
        if (errorCode === '0x0') {
          if (!res.data.result.muteRtilCodes) res.data.result.muteRtilCodes = [];
          this.myselfMuteInfo = res.data.result;
        }
      });
    },
    joinAgoraClient(result, obj, param, notInitStatus) {
      // 创建通知websocket
      if (!this.State.pageSerBusRequestWs[this.$route.query.id]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.$route.query.id
        });
      }
      this.State.isMute = !obj.speaker;
      // 如果没有摄像头，则默认图标禁用
      if (!notInitStatus) {
        this.$set(this.State.cameraStatus, result.rtilCode, this.cameraId ? obj.camera : false);
        this.$set(this.State.micStatus, result.rtilCode, this.microphoneId ? obj.mic : false);
      }
      handleLocalStorage('set', 'rtilCode', result.rtilCode);
      handleLocalStorage('set', 'manageRtilCode', result.status.managerRtil);
      // 推送状态
      // this.createdPartyLineRequest(result.rtilCode)
      // join client
      this.getMeetingInfo(param, result);
    },
    async getMeetingInfo(param, result) {
      var _this$rtc22;
      const {
        appId,
        tokenCode,
        rtilCode,
        realPartyCode,
        videoQualities
      } = param;
      const params = {
        appId,
        channel: realPartyCode + '',
        token: tokenCode,
        uid: rtilCode,
        cameraSolution: '720p_2',
        videoConfig: videoQualities,
        codec: 'h264',
        publishVideo: this.State.cameraStatus[result.rtilCode],
        publishAudio: this.State.micStatus[result.rtilCode],
        // 不能再根据当前是否有媒体设备来创建 track
        // 还要添加当前是否处于禁止状态
        // 极少数会出现 mute camera 了并且 camera 还被占了，这个时候创建会报错，而且会有即使 mute 了 camera 但是摄像头灯还在亮的问题
        video: !!this.cameraId && this.State.cameraStatus[result.rtilCode],
        audio: !!this.microphoneId && this.State.micStatus[result.rtilCode],
        getRemoteNetworks: true,
        // 传入用户选择的可用的音视频采集设备的id
        cameraId: this.devicesInfo.cameraId,
        microphoneId: this.devicesInfo.microphoneId,
        executeLocalSubscribe: true,
        startProxy: result.status.cloudProxy === 1
      };
      const uid = await ((_this$rtc22 = this.rtc) === null || _this$rtc22 === void 0 ? void 0 : _this$rtc22.join(params));
      if (uid) {
        var _this$rtc23, _this$rtc23$_client;
        this.hadOpenWebCloud = true;
        this.rtcLoaded = true;
        this.State.currentRtilCode = rtilCode;
        // 更改hostjr userId
        const userId = rtilCode + '_' + this.behaviorInfo[this.MeInfo.id] + '_' + this.partyCode;
        (_this$rtc23 = this.rtc) === null || _this$rtc23 === void 0 ? void 0 : (_this$rtc23$_client = _this$rtc23._client) === null || _this$rtc23$_client === void 0 ? void 0 : _this$rtc23$_client.enableAudioVolumeIndicator();
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
        if (!this.hasGetTimeOffset) {
          var _this$userInfo$videoQ, _this$userInfo$videoQ2;
          const offset = await this.dealTimeOffset();
          this.bestOffset = offset;
          this.hasGetTimeOffset = true;
          const fps = (_this$userInfo$videoQ = this.userInfo.videoQualities) === null || _this$userInfo$videoQ === void 0 ? void 0 : (_this$userInfo$videoQ2 = _this$userInfo$videoQ[0]) === null || _this$userInfo$videoQ2 === void 0 ? void 0 : _this$userInfo$videoQ2.fps;
          const intervalTime = fps ? Math.round(1000 / fps) : 33;
          if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
          this.sendMetadataTimer = setInterval(() => {
            this.sendMetadata();
          }, intervalTime);
        }
      }
    },
    async dealTimeOffset() {
      let bestRTT = Infinity;
      let bestOffset = 0;
      for (var i = 0; i < 10; i++) {
        const t0 = Date.now();
        const serverTime = await this.getTimeOffset();
        const t1 = Date.now();
        const rtt = t1 - t0;
        const offset = Date.now() - (serverTime + Math.round(rtt / 2));
        if (rtt < bestRTT) {
          bestRTT = rtt;
          bestOffset = offset;
        }
      }
      return bestOffset;
    },
    async getTimeOffset() {
      return await this.axios.get('/partyline-backend/base/getServerTime').then(res => {
        return res.data;
      });
    },
    sendMetadata() {
      var _this$rtc24, _this$rtc$_client;
      if (!((_this$rtc24 = this.rtc) !== null && _this$rtc24 !== void 0 && _this$rtc24.hasJoined)) return;
      const params = {
        offset: this.bestOffset,
        rtilCode: this.rtilCode,
        timestamp: Date.now() + this.bestOffset
      };
      (_this$rtc$_client = this.rtc._client) === null || _this$rtc$_client === void 0 ? void 0 : _this$rtc$_client.sendMetadata(new TextEncoder().encode(JSON.stringify(params)), function (error) {
        if (error) console.log('sendMetadata', error);
      });
    },
    createdPartyLineRequest(rtilCode) {
      const taskId = Tool.return32Str();
      if (!this.Config.urlInfo) return;
      const url = 'wss://' + this.Config.urlInfo.ccWebsocket + '/partyLineRequest?taskId=' + taskId + '&partyCode=' + this.partyCode + '&rtilCode=' + rtilCode + '&groupId=' + this.$route.query.id;
      const _self = this;
      this.PartyLineRequest = Tool.createWs(url);
      this.updataInfoTimer = setInterval(() => {
        if (_self.PartyLineRequest.client.readyState === 1) {
          const params = {
            type: 'listCurrentDevice',
            module: 'listCurrentDevice',
            data: {
              partyCode: this.partyCode,
              rtilCode: this.rtilCode
            }
          };
          _self.PartyLineRequest.send(params);
        }
      }, 5000);
    },
    userLeave(payload) {
      this.State.haveUnReadMessage = true;
      const {
        id
      } = payload;
      if (this.shareList[payload.id]) {
        this.stopShare(payload, '', 'notSendCommand');
      }
      if (this.outputRtilCode == id) {
        this.outputRtilCode = '';
      }
      if (this.largeScreenRtilCode == id) {
        this.largeScreenRtilCode = '';
      }
      this.$delete(this.rtilCodeKeyTypeVal, id);
      this.$delete(this.State.rtilCodeKeyTypeVal, id);
      this.$delete(this.participantInfo, id);
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
      this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != id);
      this.State.allRtilCodeArray = this.State.allRtilCodeArray.filter(v => v != id);
      // chat人员
      this.allPartyMembers = this.allPartyMembers.filter(v => v != payload.id);
      if (this.fullScreenInfo[payload.id]) {
        this.$set(this.fullScreenInfo, id, false);
        this.State.fullScreen = false;
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
          document.exitFullscreen();
        }
      }
      this.$set(this.channels, id, {
        id
      });
      this.$delete(this.State.deviceInfo, id);
      this.$nextTick(() => {
        this.changeLayout();
      });
    },
    async callBack({
      action,
      payload
    }) {
      var _this$rtc25, _this$rtc27, _this$rtc28, _this$rtc29, _this$rtc30;
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'voiceCheck':
          if (this.speechTimer) clearTimeout(this.speechTimer);
          this.State.aiSpeech.running = true;
          this.$refs.aiSpeech && this.$refs.aiSpeech.dealAiSpeechInfo(payload);
          this.speechTimer = setTimeout(() => {
            this.State.aiSpeech.running = false;
          }, 2000);
          break;
        case 'unlinkQuality':
          this.unlinkQuality(payload);
          break;
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.userPublished(action, payload);
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          // Me设置私聊功能，使用到
          this.MeInfo = {
            id: this.userInfo.rtilCode,
            tid: handleLocalStorage('get', 'memberId'),
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack
          };
          this.MeInfos = {
            id: this.userInfo.rtilCode,
            tid: handleLocalStorage('get', 'memberId'),
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack
          };
          this.$set(this.channels, this.userInfo.rtilCode, this.MeInfos);
          if (this.rtc && this.rtc._localVideoTrack) {
            const videoLabel = this.rtc._localVideoTrack.getTrackLabel();
            this.devicesInfo.cameraList.forEach(item => {
              if (item.label === videoLabel) {
                this.devicesInfo.cameraId = item.deviceId;
              }
            });
          }
          if ((_this$rtc25 = this.rtc) !== null && _this$rtc25 !== void 0 && _this$rtc25._localAudioTrack) {
            const audioLabel = this.rtc._localAudioTrack.getTrackLabel();
            this.devicesInfo.microphoneList.forEach(item => {
              if (item.label === audioLabel) {
                this.devicesInfo.microphoneId = item.deviceId;
              }
            });
            // 为了是否需要听见自己的声音添加的
            if (this.startHearSelf && this.hearSelf && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              var _this$rtc26;
              (_this$rtc26 = this.rtc) === null || _this$rtc26 === void 0 ? void 0 : _this$rtc26.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
            this.detecteMicMuted();
          }
          break;
        case 'autoPlayFailed':
          this.$confirm(this.$t('commonFunction.autoPlayFailed'), {
            confirmButtonText: this.$t('galleryHost.ok'),
            cancelButtonText: this.$t('commonFunction.cancel'),
            customClass: 'confirmBox',
            cancelButtonClass: 'cancelBtn',
            confirmButtonClass: 'joinBtn'
          }).then(() => {
            this.rtc && this.rtc.rePlay();
          });
          break;
        case 'local-publish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
          }
          if (payload.type.includes('video')) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          }
          if (!this.State.cameraStatus[this.userInfo.rtilCode] && this.rtc) {
            this.rtc._localVideoTrack && this.rtc._localVideoTrack.stop();
          }
          break;
        case 'local-unpublish':
          if (payload.type.includes('audio')) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          }
          if (payload.type.includes('video')) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, false);
          }
          break;
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        case 'cameraChange':
          if (!this.rtc) return;
          const cameraDeviceInfo = await ((_this$rtc27 = this.rtc) === null || _this$rtc27 === void 0 ? void 0 : _this$rtc27.getDevice());
          const {
            cameraError,
            cameraId,
            cameraList
          } = cameraDeviceInfo || {};
          this.devicesInfo = {
            ...this.devicesInfo,
            cameraError,
            cameraId,
            cameraList
          };
          if (this.rtc && this.rtc._localVideoTrack && changeDevice.device.label === this.rtc._localVideoTrack.getTrackLabel()) {
            const oldCameras = await this.rtc._AgoraRTC.getCameras();
            oldCameras[0] && this.rtc.setDevice(oldCameras[0].deviceId, 'video', type => {
              type === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'));
              this.devicesInfo.cameraId = oldCameras[0].deviceId;
            });
          }
          this.sendMediaInfoToHost(this.userInfo.rtilCode);
          break;
        case 'micChange':
          if (!this.rtc) return;
          const micDeviceInfo = await ((_this$rtc28 = this.rtc) === null || _this$rtc28 === void 0 ? void 0 : _this$rtc28.getDevice());
          const {
            microphoneError,
            microphoneId,
            microphoneList
          } = micDeviceInfo || {};
          this.devicesInfo = {
            ...this.devicesInfo,
            microphoneError,
            microphoneId,
            microphoneList
          };
          if ((_this$rtc29 = this.rtc) !== null && _this$rtc29 !== void 0 && _this$rtc29._localAudioTrack && this.rtc._localAudioTrack._deviceName.includes(changeDevice.device.label)) {
            const currentMicList = await this.rtc._AgoraRTC.getMicrophones();
            if (!currentMicList.length) return;
            const isHaveDefault = currentMicList.find(item => item.deviceId === 'default');
            this.rtc.setDevice(isHaveDefault ? 'default' : currentMicList[0].deviceId, 'audio', returnType => {
              var _this$$refs$pipBox2;
              returnType === 'success' ? this.$message.success(this.$t('common.autoSwitchNewMicSuccess')) : this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
              (_this$$refs$pipBox2 = this.$refs.pipBox) === null || _this$$refs$pipBox2 === void 0 ? void 0 : _this$$refs$pipBox2.reUseAudioWorklet();
              this.detecteMicMuted();
            });
            this.devicesInfo.microphoneId = isHaveDefault ? 'default' : currentMicList[0].deviceId;
            this.$message.warning(this.$t('common.micListChange'));
            console.log('log: ', 'The microphone list has changed');
          } else if (changeDevice.state === 'ACTIVE' && (_this$rtc30 = this.rtc) !== null && _this$rtc30 !== void 0 && _this$rtc30._localAudioTrack && this.rtc._localAudioTrack._config.microphoneId == 'default') {
            // 如果当前使用的是 default 设备并且新加入的也是 default 设备，则切换到最新的 default 设备
            const newDeviceGroupId = changeDevice.device.groupId;
            const newDeviceIsDefault = this.devicesInfo.microphoneList.find(item => item.groupId === newDeviceGroupId && item.deviceId === 'default');
            if (newDeviceIsDefault !== null && newDeviceIsDefault !== void 0 && newDeviceIsDefault.deviceId) {
              this.rtc.setDevice('default', 'audio', returnType => {
                if (returnType === 'success') {
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                  this.$refs.pipBox.reUseAudioWorklet();
                  this.detecteMicMuted();
                } else {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
              });
            }
          }
          this.sendMediaInfoToHost(this.userInfo.rtilCode);
          break;
        case 'playbackChange':
          if (!this.rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          const currentSpeakerList = await this.rtc._AgoraRTC.getPlaybackDevices();
          // 规则： 只要拔掉当前使用的设备就切到default
          if (changeDevice.state !== 'ACTIVE') {
            if (!currentSpeakerList.length) return;
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            // 当前拔掉speaker的labal
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            // 当前还在使用的speaker<=>未拔掉
            const haveUseDevice = currentLabelArray && currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice && currentSpeakerList[0]) {
              const isHaveDefault = currentSpeakerList.find(item => item.deviceId === 'default');
              const newDeviceId = isHaveDefault ? 'default' : currentSpeakerList[0].deviceId;
              handleLocalStorage('set', 'speakerId', newDeviceId);
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo3, _this$channels$rtilCo4;
                  (_this$channels$rtilCo3 = (_this$channels$rtilCo4 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo3 === void 0 ? void 0 : _this$channels$rtilCo3.call(_this$channels$rtilCo4, currentSpeakerList[0].deviceId);
                }
              });
              this.devicesInfo.speakerId = newDeviceId;
            }
          } else if (changeDevice.state === 'ACTIVE' && this.devicesInfo.speakerId == 'default') {
            // 规则： 如果当前使用的是 default 设备并且新加入的也是 default 设备，则切换到最新的 default 设备
            const newDeviceGroupId = changeDevice.device.groupId;
            const defaultSpeaker = currentSpeakerList.find(item => item.groupId === newDeviceGroupId && item.deviceId === 'default');
            if (defaultSpeaker) {
              handleLocalStorage('set', 'speakerId', 'default');
              const array = Object.keys(this.channels).filter(rtilCode => {
                return rtilCode != this.userInfo.rtilCode;
              });
              array.forEach(rtilCode => {
                if (this.channels[rtilCode].audioTrack) {
                  var _this$channels$rtilCo5, _this$channels$rtilCo6;
                  (_this$channels$rtilCo5 = (_this$channels$rtilCo6 = this.channels[rtilCode].audioTrack).setPlaybackDevice) === null || _this$channels$rtilCo5 === void 0 ? void 0 : _this$channels$rtilCo5.call(_this$channels$rtilCo6, currentSpeakerList[0].deviceId);
                }
              });
              this.devicesInfo.speakerId = 'default';
            }
          }
          this.devicesInfo.speakerList = currentSpeakerList;
          this.sendMediaInfoToHost(this.userInfo.rtilCode);
          break;
        case 'receiveMetadata':
          this.dealMetadata(payload);
          break;
      }
    },
    dealMetadata(payload) {
      const {
        metadataInfo,
        id
      } = payload;
      const info = JSON.parse(this.Uint8ArrayToString(metadataInfo));
      console.log('rtilCode: ', id, 'timestamp: ', info.timestamp, 'offset: ', info.offset);
    },
    Uint8ArrayToString(fileData) {
      let dataString = '';
      for (let i = 0; i < fileData.length; i++) {
        dataString += String.fromCharCode(fileData[i]);
      }
      return dataString;
    },
    sendShareViewPosition({
      channel,
      rtilCode,
      shareInfo
    }) {
      const obj = {
        id: rtilCode,
        videoTrack: shareInfo.videoTrack,
        audioTrack: shareInfo.audioTrack
      };
      this.$set(this.channels, rtilCode, obj);
      const params = {
        joinType: 1,
        // as pip
        partyCode: channel,
        rtilCode,
        output: true
      };
      this.axios.post('/partyline-backend/party/noLogin/startShare', params);
    },
    userPublished(action, payload) {
      this.muteAudioOrVideo(action, payload);
      const {
        id,
        mediaType
      } = payload;
      if (action == 'user-unpublished' && mediaType == 'video') {
        this.$set(this.channels, id, {
          ...this.channels[id],
          videoTrack: null
        });
      }
    },
    stopShare(payload, byClickShareIcon, notSendCommand, type) {
      if (this.shareList[payload.id] == this.userInfo.rtilCode) {
        this.shareRtilCode = '';
      }
      this.$delete(this.rtilCodeByShare, this.shareList[payload.id]);
      this.$delete(this.shareList, payload.id);
      if (!notSendCommand) this.cancalShareCommand(payload.id, type);
      if (byClickShareIcon) {
        this.cancelStopShare();
      }
    },
    cancalShareCommand(id, type) {
      const params = {
        partyCode: this.partyCode,
        module: 'cancelShareScreen',
        origin: 'commonPartyParticipate',
        msg: {
          rtilCode: id,
          stopType: type
        }
      };
      if (!id) return;
      this.axios.post('/partyline-backend/party/noLogin/command?key=85389', params);
    },
    cancelStopShare() {
      if (this.shareClient && this.shareClient._localShareTrack) {
        if (this.shareClient._localShareTrack instanceof Array) {
          this.shareClient._localShareTrack.forEach(item => {
            item._mediaStreamTrack.stop();
          });
        } else {
          this.shareClient._localShareTrack._mediaStreamTrack.stop();
        }
        this.shareClient && this.shareClient.leave();
      }
    },
    changeMute(flag) {
      this.$store.dispatch('isMute', !this.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      // 判断是否需要恢复声音
      if (this.startHearSelf && this.hearSelf && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
        var _this$rtc31;
        (_this$rtc31 = this.rtc) === null || _this$rtc31 === void 0 ? void 0 : _this$rtc31.play(this.rtc._localAudioTrack, '', {
          type: 'audio'
        });
      }
      this.changeBehaviorStatus('speaker', !this.isMute);
    },
    getVideoType(payload) {
      if (!payload.id) return;
      try {
        this.axios.post(`/partyline-backend/member/noLogin/queryByRtilCode/${payload.id}`).then(res => {
          if (!res) return;
          if (res.data.errorCode === '0x0') {
            const result = res.data.result;
            const accountId = result === null || result === void 0 ? void 0 : result.accountId.toLowerCase();
            const type = returnSourceType(result);
            this.$set(this.rtilCodeKeyTypeVal, payload.id, type);
            this.$set(this.State.rtilCodeKeyTypeVal, payload.id, type);
            this.$set(this.participantInfo, payload.id, result);
            this.$set(this.deviceType, payload.id, result.deviceType);
            this.$set(this.devicePlatform, payload.id, result.devicePlatform);
            this.$set(this.State.deviceTypeMap, payload.id, type);
            const canSave = this.canSaveToGlobal(type, payload.id);
            if (canSave) {
              this.State.allRtilCodes.push(payload.id);
            }
            if ((result.rtilCodeType == 0 || result.rtilCodeType == 1) && !accountId.includes('_sharescreen') && !this.allPartyMembers.includes(payload.id)) {
              const allPartyMemberList = this.allPartyMembers;
              allPartyMemberList.push(payload.id);
              if (this.sttRtilCode) {
                this.allPartyMembers = allPartyMemberList.filter(rtilCode => {
                  return rtilCode != this.sttRtilCode;
                });
                this.State.allRtilCodeArray = this.State.allRtilCodeArray.filter(rtilCode => {
                  return rtilCode != this.sttRtilCode;
                });
              } else {
                this.allPartyMembers = allPartyMemberList;
              }
              // this.allPartyMembers.push(payload.id)
            }

            // 判断是不是share的code,获取nickName
            let shareInitiator = '';
            let shareCode = '';
            if (accountId.indexOf('_sharescreen') > -1) {
              // 获取是谁发起的share的code
              shareCode = payload.id;
              shareInitiator = accountId.split('_sharescreen')[0];
              this.$set(this.shareList, shareCode, shareInitiator);
              this.$set(this.rtilCodeByShare, shareInitiator, shareCode);
              this.getNickName(shareInitiator, payload.id);
              this.handleRtilCodeList();
              this.State.allRtilCodeArray = this.State.allRtilCodeArray.filter(rtilCode => rtilCode != shareCode);
              // 初始化时接口返回慢于 Agora 推送消息会导致显示 audio-only 状态
              const _this = this;
              if (this.channels[shareCode]) {
                if (this.State.audioType || this.State.audioType == 2) {
                  if (_this.State.checkMainWindow) {
                    _this.channels[shareCode].hasUnsubscribe = false;
                    this.dealLocalShareScreen(shareCode, 'needControlPlay', 'unExecuteCallback', true);
                  }
                }
              }
            } else {
              this.getNickName(payload.id, payload.id, result);
            }
            if (result.deviceType === 'T' || result.deviceType === 'R') {
              if (!this.behaviorInfo[payload.id]) {
                this.$set(this.behaviorInfo, payload.id, result.deviceName);
                this.$set(this.State.globalNameInfo, payload.id, result.deviceName);
              }
            }
            if (!this.State.deviceInfo[payload.id]) {
              this.$set(this.State.deviceInfo, payload.id, result);
            }
            if (!this.behaviorInfo[payload.id]) {
              this.$set(this.behaviorInfo, payload.id, result.deviceName);
            }
            let obj = Object.assign({}, this.channels[payload.id]);
            obj = {
              ...obj,
              ...payload,
              tid: accountId,
              info: result,
              shareInitiator,
              shareCode
            };
            this.$set(this.channels, payload.id, obj);
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    setEnabledFn(value, type, origin, id, autoSwitch) {
      this.rtc && this.rtc.setEnabled(value, type, info => {
        if (info === 'failed') {
          if (type == 'audio') {
            this.noAudio = value;
          }
          if (type == 'video') {
            this.noCamera = value;
          }
          if (origin == 'host') {
            this.$message.warning(this.$t(`common.${type == 'audio' ? 'hostOperationMicroFailed' : 'hostOperationCameraFailed'}`));
            // 操作失败，给host发送消息
            this.sendToHost(type == 'audio' ? 'mic' : 'camera', 3);
          } else {
            if (value) {
              this.$message.warning(this.$t('common.operationFailed'));
            } else {
              this.$message.error(this.$t('common.closeOperationFailed'));
            }
          }
        } else {
          if (type == 'audio') {
            if (value) {
              var _this$rtc32;
              // 为了可以听见自己声音的功能添加的
              if (this.startHearSelf && this.hearSelf && id == this.userInfo.rtilCode && (_this$rtc32 = this.rtc) !== null && _this$rtc32 !== void 0 && _this$rtc32._localAudioTrack) {
                this.rtc.play(this.rtc._localAudioTrack, '', {
                  type: 'audio'
                });
              }
            } else {
              this.rtc.stop(this.rtc._localAudioTrack);
            }
            this.changeBehaviorStatus('mic', !value, origin, autoSwitch);
            if (origin == 'host') {
              // message更换为弹窗
              if (value) {
                this.CameraTips.hideCancel = true;
                this.CameraTips.hideSave = true;
                this.CameraTips.showGotIt = true;
                this.CameraTips.show = true;
                this.CameraTips.content = `<div class="end">${this.$t('remainWords.hostHasMicrophoneOn')}</div>`;
              } else {
                this.CameraTips.hideCancel = true;
                this.CameraTips.hideSave = true;
                this.CameraTips.showGotIt = true;
                this.CameraTips.show = true;
                this.CameraTips.content = `<div class="end">${this.$t('commonFunction.hasMicrophoneOff')}</div>`;
              }
              // this.$message.warning(value ? this.$t('remainWords.hostHasMicrophoneOn') : this.$t('commonFunction.hasMicrophoneOff'))
            }
          }

          if (type == 'video') {
            this.changeBehaviorStatus('camera', !value, origin, autoSwitch);
            if (origin == 'host') {
              if (!value) {
                this.CameraTips.hideCancel = true;
                this.CameraTips.hideSave = true;
                this.CameraTips.showGotIt = true;
                this.CameraTips.show = true;
                this.CameraTips.content = `<div class="end">${this.$t('commonFunction.hasCameraOff')}</div>`;
                // this.$message.warning(this.$t('commonFunction.hasCameraOff'))
              }
            }
          }
        }
      }, {
        controlsMedia: value
      });
    },
    changeBehaviorStatus(key, value, origin, autoSwitch) {
      if (autoSwitch == 'autoSwitch' || !this.userInfo.rtilCode || !this.userInfo.realPartyCode) return;
      // 更新状态
      const params = [{
        mark: this.userInfo.rtilCode + '',
        annotation: this.userInfo.realPartyCode,
        key,
        value
      }];
      try {
        this.axios.post(`/partyline-backend/behavior/noLogin/setList?origin=${origin ? 'host' : 'participate'}`, params).then(res => {
          if (res.data.errorCode == '0x0') {
            if (key == 'speaker') {
              this.userInfo.behavior.speaker = !value;
            }
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    async shareScreen(shareType) {
      if (shareType === 'stopShare') {
        this.stopShare({
          id: this.shareRtilCode
        }, 'byClickShareIcon', false, 'userFootClick');
        return;
      }
      const params = {
        memberId: `${this.userInfo.rtilCode}_sharescreen`,
        partyCode: this.partyCode,
        role: 0,
        type: 3,
        whetherSendViewPosition: 0
      };
      this.axios.post('/partyline-backend/party/noLogin/join', params, {
        errorTip: false
      }).then(async res => {
        if (res.data.errorCode === '0x0') {
          const {
            appId,
            tokenCode,
            rtilCode,
            status
          } = res.data.result;
          const temp = {
            appId,
            channel: this.partyCode + '',
            token: tokenCode,
            uid: rtilCode,
            share: true,
            subscribeRemote: false,
            status
          };
          this.shareRtilCode = rtilCode;
          this.$set(this.shareList, rtilCode, this.userInfo.rtilCode);
          this.$set(this.State.globalNameInfo, rtilCode, this.behaviorInfo[this.userInfo.rtilCode]);
          this.$set(this.State.localShareInfo, rtilCode, this.userInfo.rtilCode);
          this.shareClient = new newAgoraClient();
          this.shareClient.on('start-share', this.dealStartShare);
          this.shareClient.on('stop-share', this.dealStopShare);
          await this.shareClient.join(temp); // 初始化视频流
          this.saveShareName(res.data.result);
        }
      });
    },
    dealStartShare(payload) {
      this.sendShareViewPosition(payload);
    },
    dealStopShare(rtilCode) {
      console.log('stop screen share by stop-share');
      this.stopShare({
        id: rtilCode
      }, false, false, 'agoraStopShareCallback');
    },
    saveShareName({
      rtilCode
    }) {
      if (!rtilCode || !this.partyCode) return;
      const params = [{
        mark: String(rtilCode),
        annotation: this.partyCode + '',
        key: 'nickName',
        notify: true,
        value: this.behaviorInfo[this.MeInfo.id] + '_Screen_Share',
        initiator: String(rtilCode)
      }];
      this.axios.post('/partyline-backend/behavior/noLogin/setList', params).then(res => {});
    },
    unlinkQuality(payload) {
      if (!payload.type) return;
      this.$set(this.remoteNetWorks, payload.id, {
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      });
    },
    wsRemoveEventListener() {
      wsDispatcher.unregister('startStt', 'pStartStt');
      wsDispatcher.unregister('stopStt', 'pStoptStt');
      wsDispatcher.unregister('setTalkBack', 'pSetTalkBack');
      wsDispatcher.unregister('cancelTalkBack', 'pCancelTalkBack');
      wsDispatcher.unregister('endParty', 'pEndParty');
      wsDispatcher.unregister('rtilLiveStatus', 'pRtilStatus');
      wsDispatcher.unregister('flipVideo', 'pFlipVideo');
      wsDispatcher.unregister('setParticipantTalkBack', 'pTalkBack');
      wsDispatcher.unregister('cancelParticipantTalkBack', 'CancelPTalkBack');
      wsDispatcher.unregister('setOutput', 'pSetOutput');
      wsDispatcher.unregister('cancelOutput', 'pCancelOutput');
      wsDispatcher.unregister('viewPositionV2', 'pViewPositionV2');
      wsDispatcher.unregister('setBehaviors', 'pSetBehaviors');
      wsDispatcher.unregister('controlBehavior', 'pControlBehavior');
      wsDispatcher.unregister('moveParticipants', 'pMoveParticipants');
      wsDispatcher.unregister('removeParticipant', 'pRemoveParticipant');
      wsDispatcher.unregister('intercom', 'pIntercom');
      wsDispatcher.unregister('videoQuality', 'pVideoQuality');
      wsDispatcher.unregister('startPrivateConversation', 'pStartPrivateConversation');
      wsDispatcher.unregister('cancelPrivateConversation', 'pCancelPrivateConversation');
      wsDispatcher.unregister('notify', 'pNotify');
      wsDispatcher.unregister('button', 'pButton');
      wsDispatcher.unregister('audioOn', 'pAudioON');
      wsDispatcher.unregister('audioOff', 'pAudioOFF');
      wsDispatcher.unregister('talkOn', 'pTalkON');
      wsDispatcher.unregister('talkOff', 'pTalkOFF');
      wsDispatcher.unregister('pushToTalk', 'pPushToTalk');
    }
  },
  async beforeRouteLeave(to, from, next) {
    this.rtc && (await this.rtc.leave(this.hadOpenWebCloud ? 'closeCloudProxy' : ''));
    this.rtc = null;
    this.cancelStopShare();
    if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
    if (this.shareRtilCode) this.cancalShareCommand(this.shareRtilCode, 'routeLeave');
    this.shareClient && this.shareClient.leave();
    this.PartyLineRequest && this.PartyLineRequest.close();
    this.State.pageSerBusRequestWs[this.$route.query.id] && this.State.pageSerBusRequestWs[this.$route.query.id].close();
    this.State.pageSerBusRequestWs[this.$route.query.id] = '';
    if (this.State.volumeBar) this.State.volumeBar.destroyAudioContext();
    Bus.$off('notify');
    if (this.sendMetadataTimer) clearInterval(this.sendMetadataTimer);
    this.wsRemoveEventListener();
    window.removeEventListener('resize', this.changeLayout);
    window.removeEventListener('keydown', this.listenerKeyDown);
    window.removeEventListener('keyup', this.listenerKeyUp);
    next();
  }
};